import { useState, useReducer, useEffect } from "react";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import axios from "axios";
import { useSelector } from "react-redux";
import "./registrationform.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import { statesAndLgas } from "./registrationStatesAndLGA.js";
import RegistrationCompleted from "./RegistrationCompleted.jsx";
import IsLoading from "../../../isLoading.jsx";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import {
  FileUploads,
  PassportUpload,
  SignatureRegUpload,
} from "./regFormComps/FileUploads.jsx";
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";

let appData;
const Modal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          padding: "3.4rem",
          borderRadius: "8px",
          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
          width: "40%",
          position: "relative",
          color: "#333",
          textAlign: "center",
        }}
      >
        <button
          style={{
            position: "absolute",
            top: "10px",
            right: "-8%",
            color: "gray",
            cursor: "pointer",
            border: "none",
            background: "none",
            fontSize: "3.8rem",
            fontWeight: "100",
          }}
          onClick={onClose}
        >
          <CloseIcon style={{ fontSize: "3.6rem" }} />
        </button>
        {children}
      </div>
    </div>
  );
};
export default function RegistrationForm() {
  const redirect = useNavigate();
  const [loading, setLoading] = useState(false);
  const [switchForm, setSwitchForm] = useState(1);
  const { id } = useParams();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [passport, setPassport] = useState(false);
  const [signature, setSignature] = useState(false);
  const [agreed, setAgreed] = useState(false);
  const [applicantData, setApplicantData] = useReducer(
    (request, response) => {
      return { ...request, ...response };
    },
    {
      agree: "",
      Date_of_birth: "",
      Nationality: "",
      State_of_origin: "",
      Local_Govt_Area: "",
      Residential_address: "",
      Contact_address: "",
      Marital_status: "",
      No__of_sitting: "1",
      jamb_number: "",
      jamb_score: "",
      // First Sitting Resutls
      fcenter_name: "",
      fcenter_number: "",
      fexams_number: "",
      fexams_type: "",
      fexams_year: "",
      fcourse1: "Mathematics",
      fscore1: "",
      fcourse2: "English Language",
      fscore2: "",
      fcourse3: "Biology",
      fscore3: "",
      fcourse4: "Physics",
      fscore4: "",
      fcourse5: "Chemistry",
      fscore5: "",
      fcourse6: "",
      fscore6: "",
      fcourse7: "",
      fscore7: "",
      fcourse8: "",
      fscore8: "",
      fcourse9: "",
      fscore9: "",
      // SECOND Sitting Resutls
      scenter_name: "",
      scenter_number: "",
      sexams_number: "",
      sexams_type: "",
      sexams_year: "",
      scourse1: "Mathematics",
      sscore1: "",
      scourse2: "English Language",
      sscore2: "",
      scourse3: "Biology",
      sscore3: "",
      scourse4: "Physics",
      sscore4: "",
      scourse5: "Chemistry",
      sscore5: "",
      scourse6: "",
      sscore6: "",
      scourse7: "",
      sscore7: "",
      scourse8: "",
      sscore8: "",
      scourse9: "",
      sscore9: "",

      // EDUCATIONAL RECORDS
      priName: "",
      priFrom: "",
      priTo: "",
      priCert: "",
      junior_sec_Name: "",
      junior_sec_From: "",
      junior_sec_To: "",
      junior_sec_Cert: "",
      senior_sec_Name: "",
      senior_sec_From: "",
      senior_sec_To: "",
      senior_sec_Cert: "",
      // Refrees informations
      firstRef_name: "",
      firstRef_postion: "",
      firstRef_email: "",
      firstRef_phone: "",
      firstRef_address: "",
      secondRef_name: "",
      secondRef_postion: "",
      secondRef_email: "",
      secondRef_phone: "",
      secondRef_address: "",
      nok_name: "",
      nok_postion: "",
      nok_relationship: "",
      nok_phone: "",
      nok_address: "",
    },
  );

  const { continueationData } = useSelector(
    (state) => state.applictaionForm.finalForm,
  );

  const data = {
    marital_status: applicantData.Marital_status,
    nationality: applicantData.Nationality,
    state_of_origin: applicantData.State_of_origin,
    lga_of_origin: applicantData.Local_Govt_Area,
    home_address: applicantData.Residential_address,
    Date_of_birth: applicantData.Date_of_birth,
    no_of_sitting: applicantData.No__of_sitting,
    jamb_number: applicantData.jamb_number,
    jamb_score: applicantData.jamb_score,

    // first sitting information
    first_sitting_center_name: applicantData.fcenter_name,
    first_sitting_center_number: applicantData.fcenter_number,
    first_sitting_exam_number: applicantData.fexams_number,
    first_sitting_exam_type: applicantData.fexams_type,
    first_sitting_exam_year: applicantData.fexams_year,
    fcourse1: applicantData.fcourse1,
    fscore1: applicantData.fscore1,
    fcourse2: applicantData.fcourse2,
    fscore2: applicantData.fscore2,
    fcourse3: applicantData.fcourse3,
    fscore3: applicantData.fscore3,
    fcourse4: applicantData.fcourse4,
    fscore4: applicantData.fscore4,
    fcourse5: applicantData.fcourse5,
    fscore5: applicantData.fscore5,
    fcourse6: applicantData.fcourse6,
    fscore6: applicantData.fscore6,
    fcourse7: applicantData.fcourse7,
    fscore7: applicantData.fscore7,
    fcourse8: applicantData.fcourse8,
    fscore8: applicantData.fscore8,
    fcourse9: applicantData.fcourse9,
    fscore9: applicantData.fscore9,

    // second sitting information
    ssitting_center_name: applicantData.scenter_name,
    ssitting_center_number: applicantData.scenter_number,
    ssitting_exam_number: applicantData.sexams_number,
    ssitting_exams_type: applicantData.sexams_type,
    ssitting_exam_year: applicantData.sexams_year,
    scourse1: applicantData.scourse1,
    sscore1: applicantData.sscore1,
    scourse2: applicantData.scourse2,
    sscore2: applicantData.sscore2,
    scourse3: applicantData.scourse3,
    sscore3: applicantData.sscore3,
    scourse4: applicantData.scourse4,
    sscore4: applicantData.sscore4,
    scourse5: applicantData.scourse5,
    sscore5: applicantData.sscore5,
    scourse6: applicantData.scourse6,
    sscore6: applicantData.sscore6,
    scourse7: applicantData.scourse7,
    sscore7: applicantData.sscore7,
    scourse8: applicantData.scourse8,
    sscore8: applicantData.sscore8,
    scourse9: applicantData.scourse9,
    sscore9: applicantData.sscore9,

    // education institution attended
    primary_sch_name: applicantData.priName,
    primary_sch_started: applicantData.priFrom,
    Primary_sch_end: applicantData.priTo,
    primary_sch_cert: applicantData.priCert,

    junior_sec_sch_name: applicantData.junior_sec_Name,
    junior_sec_sch_from: applicantData.junior_sec_From,
    junior_sec_sch_end: applicantData.junior_sec_To,
    junior_sec_sch_cert: applicantData.junior_sec_Cert,

    senior_sec_sch_name: applicantData.senior_sec_Name,
    senior_sec_sch_from: applicantData.senior_sec_From,
    senior_sec_sch_end: applicantData.senior_sec_To,
    senior_sec_sch_cert: applicantData.senior_sec_Cert,

    // Refrees informations
    ref1_name: applicantData.firstRef_name,
    ref1_address: applicantData.firstRef_address,
    ref1_email: applicantData.firstRef_email,
    ref1_phone: applicantData.firstRef_phone,
    ref2_name: applicantData.secondRef_name,
    ref2_address: applicantData.secondRef_address,
    ref2_email: applicantData.secondRef_email,
    ref2_phone: applicantData.secondRef_phone,
    nok_name: applicantData.nok_name,
    nok_address: applicantData.nok_address,
    nok_relation: applicantData.nok_relationship,
    nok_phone: applicantData.nok_phone,
    agree: applicantData.agree,
  };

  const postApplicatonForm = async () => {
    setLoading(true);
    await axios
      .put(
        `${process.env.REACT_APP_SERVER_SCRIPT_HOST}/student_application/continue_application/${id}`,
        data,
      )
      .then((response) => {
        appData = response.data.data;
        if (response.status == 200) {
          executeCompleted();
          setSwitchForm(3);
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const formSwitching = () => {
    switch (switchForm) {
      // case 1:
      //   return <FormData />;
      case 2:
        return <PreviewForm />;
      case 3:
        return <SubmitedForm />;
      default:
        return "";
    }
  };
  // FUNTIONS FOR THE STATE SELECTIONS
  const [selectedState, setSelectedState] = useState("");
  const [localGovernments, setLocalGovernments] = useState([]);

  const handleStateChange = (e) => {
    const state = e.target.value;
    setSelectedState(state);
    setApplicantData({ State_of_origin: e.target.value });
    setLocalGovernments(statesAndLgas[state] || []);
  };
  // ------------------------
  // const [dob, setDob] = useState(null);

  // Calculate minimum date (e.g., 120 years ago)
  const maxDate = new Date();
  const minDate = new Date(
    maxDate.getFullYear() - 120,
    maxDate.getMonth(),
    maxDate.getDate(),
  );

  const PreviewForm = () => {
    return (
      <div className="fx-cl space2">
        <header className="fx-cl spacem">
          <h2>Application form preview</h2>
        </header>
        <section className="sectionPreview">
          <div className="fx-cl">
            <div className="fx-ac ">
              <div
                className="regPreviewContent fx-cl space2"
                style={{ width: "100%" }}
              >
                <div className=" fx-ac space2">
                  <div className="contentsAd fx-cl spacem">
                    <h2>Personal information</h2>
                  </div>
                </div>
                <div className="g g2 space2">
                  <div className="fx-cl spacem">
                    <h3>First name</h3>
                    <span>{continueationData?.first_Name}</span>
                  </div>
                  <div className="fx-cl spacem">
                    <h3>Last name:</h3>
                    <span>
                      {continueationData?.sur_Name +
                        " " +
                        continueationData?.other_Name}
                    </span>
                  </div>
                  <div className="fx-cl spacem">
                    <h3>Email</h3>
                    <span>{continueationData?.email}</span>
                  </div>
                  <div className="fx-cl spacem">
                    <h3>Phone number</h3>
                    <span>+234 {continueationData?.phone_number}</span>
                  </div>
                  <div className="fx-cl spacem">
                    <h3>Application Number: </h3>
                    <span>{id}</span>
                  </div>
                  <div className="fx-cl spacem">
                    <h3>Programme of study</h3>
                    <span>{continueationData?.programme_of_study}</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="regPreviewContent fx-cl space2">
              <div className=" fx-ac space3">
                <div className="contentsAd fx-cl spacem">
                  <h2>Address</h2>
                </div>
              </div>
              <div className="g g2 space2">
                <div className="fx-cl spacem">
                  <h3>Nationality</h3>
                  <span>{applicantData.Nationality}</span>
                </div>
                <div className="fx-cl spacem">
                  <h3>State of origin</h3>
                  <span>{applicantData.State_of_origin}</span>
                </div>
                <div className="fx-cl spacem">
                  <h3>Local Gov't Area</h3>
                  <span>{applicantData.Local_Govt_Area}</span>
                </div>
                <div className="fx-cl spacem">
                  <h3>Address</h3>
                  <span>{applicantData.Residential_address}</span>
                </div>
              </div>
            </div>
            <div className="regPreviewContent fx-cl space2">
              <div className=" fx-ac space3">
                <div className="contentsAd fx-cl spacem">
                  <h2>Educational Record</h2>
                </div>
              </div>
              <div className="g g4 space2">
                <div className="fx-cl spacem">
                  <h3>Primary school</h3>
                  <span>{applicantData.priName}</span>
                </div>
                <div className="fx-cl spacem">
                  <h3>Year started</h3>
                  <span>{applicantData.priFrom}</span>
                </div>
                <div className="fx-cl spacem">
                  <h3>Year of Grad</h3>
                  <span>{applicantData.priTo}</span>
                </div>
                <div className="fx-cl spacem">
                  <h3>Certificate obtained</h3>
                  <span>{applicantData.priCert}</span>
                </div>
              </div>
              <div className="g g4 space2">
                <div className="fx-cl spacem">
                  <h3>Junior Secondary school</h3>
                  <span>{applicantData.junior_sec_Name}</span>
                </div>
                <div className="fx-cl spacem">
                  <h3>Year started</h3>
                  <span>{applicantData.junior_sec_From}</span>
                </div>
                <div className="fx-cl spacem">
                  <h3>Year of Grad</h3>
                  <span>{applicantData.junior_sec_To}</span>
                </div>
                <div className="fx-cl spacem">
                  <h3>Certificate obtained</h3>
                  <span>{applicantData.junior_sec_Cert}</span>
                </div>
              </div>
              <div className="g g4 space2">
                <div className="fx-cl spacem">
                  <h3>Senior Secondary school</h3>
                  <span>{applicantData.senior_sec_Name}</span>
                </div>
                <div className="fx-cl spacem">
                  <h3>Year started</h3>
                  <span>{applicantData.senior_sec_From}</span>
                </div>
                <div className="fx-cl spacem">
                  <h3>Year of Grad</h3>
                  <span>{applicantData.senior_sec_To}</span>
                </div>
                <div className="fx-cl spacem">
                  <h3>Certificate obtained</h3>
                  <span>{applicantData.senior_sec_Cert}</span>
                </div>
              </div>
            </div>
            <div className="regPreviewContent fx-cl space2">
              <div className=" fx-ac space3">
                <div className="contentsAd fx-cl spacem">
                  <h2>O'Level result</h2>
                </div>
              </div>
              <div className="g g2">
                <div className="fx-cl">
                  <div className="fx-cl">
                    <div className="g g3 space2">
                      <div className="fx-cl spacem">
                        <h3>S/N</h3>
                      </div>
                      <div className="fx-cl spacem">
                        <h3>Course name</h3>
                      </div>
                      <div className="fx-cl spacem">
                        <h3>Grade</h3>
                      </div>
                    </div>
                    <div className="g g3 space2">
                      <div className="fx-cl spacem">
                        <span>1</span>
                      </div>
                      <div className="fx-cl spacem">
                        <span>{applicantData.fcourse1}</span>
                      </div>
                      <div className="fx-cl spacem">
                        <span>{applicantData.fscore1}</span>
                      </div>
                    </div>
                    <div className="g g3 space2">
                      <div className="fx-cl spacem">
                        <span>2</span>
                      </div>
                      <div className="fx-cl spacem">
                        <span>{applicantData.fcourse2}</span>
                      </div>
                      <div className="fx-cl spacem">
                        <span>{applicantData.fscore2}</span>
                      </div>
                    </div>
                    <div className="g g3 space2">
                      <div className="fx-cl spacem">
                        <span>3</span>
                      </div>
                      <div className="fx-cl spacem">
                        <span>{applicantData.fcourse3}</span>
                      </div>
                      <div className="fx-cl spacem">
                        <span>{applicantData.fscore3}</span>
                      </div>
                    </div>
                    <div className="g g3 space2">
                      <div className="fx-cl spacem">
                        <span>4</span>
                      </div>
                      <div className="fx-cl spacem">
                        <span>{applicantData.fcourse4}</span>
                      </div>
                      <div className="fx-cl spacem">
                        <span>{applicantData.fscore4}</span>
                      </div>
                    </div>
                    <div className="g g3 space2">
                      <div className="fx-cl spacem">
                        <span>5</span>
                      </div>
                      <div className="fx-cl spacem">
                        <span>{applicantData.fcourse5}</span>
                      </div>
                      <div className="fx-cl spacem">
                        <span>{applicantData.fscore5}</span>
                      </div>
                    </div>
                    <div className="g g3 space2">
                      <div className="fx-cl spacem">
                        <span>6</span>
                      </div>
                      <div className="fx-cl spacem">
                        <span>{applicantData.fcourse6} </span>
                      </div>
                      <div className="fx-cl spacem">
                        <span>{applicantData.fscore6}</span>
                      </div>
                    </div>
                    <div className="g g3 space2">
                      <div className="fx-cl spacem">
                        <span>7</span>
                      </div>
                      <div className="fx-cl spacem">
                        <span>{applicantData.fcourse7}</span>
                      </div>
                      <div className="fx-cl spacem">
                        <span>{applicantData.fscore7}</span>
                      </div>
                    </div>
                    <div className="g g3 space2">
                      <div className="fx-cl spacem">
                        <span>8</span>
                      </div>
                      <div className="fx-cl spacem">
                        <span>{applicantData.fcourse8}</span>
                      </div>
                      <div className="fx-cl spacem">
                        <span>{applicantData.fscore8}</span>
                      </div>
                    </div>
                    <div className="g g3 space2">
                      <div className="fx-cl spacem">
                        <span>9</span>
                      </div>
                      <div className="fx-cl spacem">
                        <span>{applicantData.fcourse9}</span>
                      </div>
                      <div className="fx-cl spacem">
                        <span>{applicantData.fscore9}</span>
                      </div>
                    </div>
                  </div>
                </div>
                {applicantData.No__of_sitting === "2" ? (
                  <div className="fx-cl">
                    <div className="fx-cl">
                      <div className="g g3 space2">
                        <div className="fx-cl spacem">
                          <h3>S/N</h3>
                        </div>
                        <div className="fx-cl spacem">
                          <h3>Course name</h3>
                        </div>
                        <div className="fx-cl spacem">
                          <h3>Grade</h3>
                        </div>
                      </div>
                      <div className="g g3 space2">
                        <div className="fx-cl spacem">
                          <span>1</span>
                        </div>
                        <div className="fx-cl spacem">
                          <span>{applicantData.course1}</span>
                        </div>
                        <div className="fx-cl spacem">
                          <span>{applicantData.score1}</span>
                        </div>
                      </div>
                      <div className="g g3 space2">
                        <div className="fx-cl spacem">
                          <span>2</span>
                        </div>
                        <div className="fx-cl spacem">
                          <span>{applicantData.scourse2}</span>
                        </div>
                        <div className="fx-cl spacem">
                          <span>{applicantData.sscore2}</span>
                        </div>
                      </div>
                      <div className="g g3 space2">
                        <div className="fx-cl spacem">
                          <span>3</span>
                        </div>
                        <div className="fx-cl spacem">
                          <span>{applicantData.scourse3}</span>
                        </div>
                        <div className="fx-cl spacem">
                          <span>{applicantData.sscore3}</span>
                        </div>
                      </div>
                      <div className="g g3 space2">
                        <div className="fx-cl spacem">
                          <span>4</span>
                        </div>
                        <div className="fx-cl spacem">
                          <span>{applicantData.scourse4}</span>
                        </div>
                        <div className="fx-cl spacem">
                          <span>{applicantData.sscore4}</span>
                        </div>
                      </div>
                      <div className="g g3 space2">
                        <div className="fx-cl spacem">
                          <span>5</span>
                        </div>
                        <div className="fx-cl spacem">
                          <span>{applicantData.scourse5}</span>
                        </div>
                        <div className="fx-cl spacem">
                          <span>{applicantData.sscore5}</span>
                        </div>
                      </div>
                      <div className="g g3 space2">
                        <div className="fx-cl spacem">
                          <span>6</span>
                        </div>
                        <div className="fx-cl spacem">
                          <span>{applicantData.scourse6} </span>
                        </div>
                        <div className="fx-cl spacem">
                          <span>{applicantData.sscore6}</span>
                        </div>
                      </div>
                      <div className="g g3 space2">
                        <div className="fx-cl spacem">
                          <span>7</span>
                        </div>
                        <div className="fx-cl spacem">
                          <span>{applicantData.scourse7}</span>
                        </div>
                        <div className="fx-cl spacem">
                          <span>{applicantData.sscore7}</span>
                        </div>
                      </div>
                      <div className="g g3 space2">
                        <div className="fx-cl spacem">
                          <span>8</span>
                        </div>
                        <div className="fx-cl spacem">
                          <span>{applicantData.scourse8}</span>
                        </div>
                        <div className="fx-cl spacem">
                          <span>{applicantData.sscore8}</span>
                        </div>
                      </div>
                      <div className="g g3 space2">
                        <div className="fx-cl spacem">
                          <span>9</span>
                        </div>
                        <div className="fx-cl spacem">
                          <span>{applicantData.scourse9}</span>
                        </div>
                        <div className="fx-cl spacem">
                          <span>{applicantData.sscore9}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
            <div className="regPreviewContent fx-cl space2">
              <div className=" fx-ac space3">
                <div className="contentsAd fx-cl spacem">
                  <h2>REFEREES</h2>
                </div>
              </div>
              <div className="g g4 space2">
                <div className="fx-cl spacem">
                  <h3>Referee Full Name</h3>
                  <span>{applicantData.firstRef_name}</span>
                </div>
                <div className="fx-cl spacem">
                  <h3>Address</h3>
                  <span>{applicantData.firstRef_address}</span>
                </div>
                <div className="fx-cl spacem">
                  <h3>Email</h3>
                  <span>{applicantData.firstRef_email}</span>
                </div>
                <div className="fx-cl spacem">
                  <h3>Phone Number</h3>
                  <span>{applicantData.firstRef_phone}</span>
                </div>
              </div>
              <div className="g g4 space2">
                <div className="fx-cl spacem">
                  <h3>Referee Full Name</h3>
                  <span>{applicantData.secondRef_name}</span>
                </div>
                <div className="fx-cl spacem">
                  <h3>Address</h3>
                  <span>{applicantData.secondRef_address}</span>
                </div>
                <div className="fx-cl spacem">
                  <h3>Email</h3>
                  <span>{applicantData.secondRef_email}</span>
                </div>
                <div className="fx-cl spacem">
                  <h3>Phone Number</h3>
                  <span>{applicantData.secondRef_phone}</span>
                </div>
              </div>
              <div className="g g4 space2">
                <div className="fx-cl spacem">
                  <h3>Referee Full Name</h3>
                  <span>{applicantData.nok_name}</span>
                </div>
                <div className="fx-cl spacem">
                  <h3>Address</h3>
                  <span>{applicantData.nok_address}</span>
                </div>
                <div className="fx-cl spacem">
                  <h3>Relationship</h3>
                  <span>{applicantData.nok_relationship}</span>
                </div>
                <div className="fx-cl spacem">
                  <h3>Phone Number</h3>
                  <span>{applicantData.nok_phone}</span>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="fx-jb space3">
          <button onClick={() => setSwitchForm(1)}>Prev</button>

          <button
            onClick={() => postApplicatonForm()}
            style={{ backgroundColor: "#64f727" }}
          >
            Submit Application
          </button>
        </div>
      </div>
    );
  };
  async function executeCompleted() {
    setLoading(true);
    await axios
      .put(
        `${process.env.REACT_APP_SERVER_SCRIPT_HOST}/student_application/continue_application/completed/${id}`,
      )
      .then((response) => {
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
  }
  async function wakeUP() {
    await axios
      .get(`${process.env.REACT_APP_SERVER_SCRIPT_HOST}/wakeUP`)
      .then((response) => {})
      .catch((error) => {
        console.log(error);
      });
  }
  const SubmitedForm = () => {
    return (
      <div className="succCont fx-cl fx-ac space2">
        <div className="successSub">
          <DoneIcon style={{ fontSize: "5.8rem" }} />
        </div>
        <h3>
          Thank you{" "}
          {appData.first_Name +
            " " +
            appData.sur_Name +
            " " +
            appData.other_Name}
        </h3>
        <p
          style={{ fontSize: "1.4rem", fontWeight: "200", textAlign: "center" }}
        >
          "Congratulations! You have successfully completed all the required
          steps for registration!"
        </p>
        <div className="fx-jc space3">
          <button onClick={() => redirect("/")}>Close</button>

          <button
            style={{ backgroundColor: "#18c07a" }}
            onClick={redirect(`/continue_application/${id}/print_form`)}
          >
            Print Form
          </button>
        </div>
      </div>
    );
  };

  useEffect(() => {
    wakeUP();
  }, []);
  return (
    <>
      {loading ? <IsLoading /> : null}

      {continueationData?.account_status.registration_status === "completed" ? (
        <RegistrationCompleted />
      ) : (
        <section className="section-student-conti-reg">
          {switchForm === 3 ? (
            <SubmitedForm />
          ) : (
            <div className="student-conti-reg-container">
              <div className="student-conti-reg-form-cont fx-cl space3">
                <div className="student-registration-form fx-cl space2">
                  {switchForm == 1 ? (
                    <div className="ContinueReg fx-cl space2">
                      <header className="fx-cl spacem">
                        <h2 style={{ textAlign: "center" }}>
                          CONTINUE APPLICATION
                        </h2>
                      </header>
                      <div className="regPreviewContent fx-cl space2">
                        <div className=" fx-ac space2">
                          <div className="contentsAd fx-cl spacem">
                            <h2>Personal information</h2>
                          </div>
                        </div>

                        <div
                          className="contiRegInfo"
                          style={{ position: "relative" }}
                        >
                          <div className="g g2 space2 rwdRegExistDb">
                            <div className="fx-cl spacem">
                              <h3>Full name</h3>
                              <span>
                                {continueationData?.first_Name +
                                  " " +
                                  continueationData?.sur_Name +
                                  " " +
                                  continueationData?.other_Name}
                              </span>
                            </div>
                            <div className="fx-cl spacem">
                              <h3>Apllication number:</h3>
                              <span>{id}</span>
                            </div>
                            <div className="fx-cl spacem">
                              <h3>Email</h3>
                              <span>{continueationData?.email}</span>
                            </div>
                            <div className="fx-cl spacem">
                              <h3>Phone number</h3>
                              <span>+234{continueationData?.phone_number}</span>
                            </div>
                            <div className="fx-cl spacem">
                              <h3>Programme of study</h3>
                              <span>
                                {continueationData?.programme_of_study}
                              </span>
                            </div>
                          </div>
                          <div className="fx-cl spacem ">
                            <span className="passportRwdRegForm">
                              <PassportUpload setPassport={setPassport} />
                            </span>
                            <span
                              className="rwdHide"
                              style={{ color: "red", fontSize: "1rem" }}
                            >
                              Please upload passport here
                            </span>
                          </div>
                        </div>
                      </div>
                      {/* -------------------------------------NEW APPLICATION DATA ------------------------------------- */}
                      <div className="fx-cl space2 regformSect">
                        <div className="tag">
                          <span>Applicant information</span>
                        </div>
                        <div className="rwdG5 g g5 space2 regFormfloat">
                          <div className="fx-cl spacem">
                            <label htmlFor="text">JAMB Number:</label>
                            <div className="fx-ac space1 regInputCont">
                              <input
                                type="text"
                                name="jamb_number"
                                value={applicantData.jamb_number}
                                onChange={(event) =>
                                  setApplicantData({
                                    jamb_number: event.target.value,
                                  })
                                }
                              />
                            </div>
                          </div>
                          <div className="fx-cl spacem">
                            <label htmlFor="text">JAMB Score:</label>
                            <div className="fx-ac space1 regInputCont">
                              <input
                                type="number"
                                name="jamb_score"
                                value={applicantData.jamb_score}
                                onChange={(event) =>
                                  setApplicantData({
                                    jamb_score: event.target.value,
                                  })
                                }
                              />
                            </div>
                          </div>

                          <div className="fx-cl spacem">
                            <label htmlFor="text">Date of birth:</label>
                            <div className="fx-ac space1 regInputCont">
                              <div className="date-picker-wrapper">
                                <DatePicker
                                  name="Date_of_birth"
                                  id="dob-picker"
                                  selected={applicantData.Date_of_birth}
                                  onChange={(date) =>
                                    setApplicantData({ Date_of_birth: date })
                                  }
                                  dateFormat="dd MM, yyyy" // Customize date format
                                  className="date-picker-input" // Apply custom styles
                                  placeholderText="DD/MM/YYYY" // Placeholder text
                                  isClearable // Allow clearing the date
                                  showPopperArrow={false} // Hide arrow on popper
                                  showMonthDropdown // Show month dropdown
                                  showYearDropdown // Show year dropdown
                                  dropdownMode="select" // Use dropdowns for month and year selection
                                  maxDate={maxDate} // Prevent future dates
                                  minDate={minDate} // Prevent selecting too far in the past
                                />
                              </div>
                            </div>
                          </div>
                          <div className="fx-cl spacem">
                            <label htmlFor="text">Nationality:</label>
                            <div className="fx-ac space1 regInputCont">
                              <input
                                type="text"
                                name="nationality"
                                value={applicantData.Nationality}
                                onChange={(event) =>
                                  setApplicantData({
                                    Nationality: event.target.value,
                                  })
                                }
                              />
                            </div>
                          </div>
                          <div className="fx-cl spacem">
                            <label htmlFor="text">State of origin:</label>
                            <div className="fx-ac space1 regInputCont">
                              <select
                                name="state_of_origin"
                                value={selectedState}
                                onChange={handleStateChange}
                              >
                                <option value="">Select state</option>
                                {Object.keys(statesAndLgas).map((state) => (
                                  <option key={state} value={state}>
                                    {state}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                          <div className="fx-cl spacem">
                            <label htmlFor="text">Local Gov't Area:</label>
                            <div className="fx-ac space1 regInputCont">
                              <select
                                name="lga_of_origin"
                                disabled={!selectedState}
                                value={applicantData.Local_Govt_Area}
                                onChange={(event) =>
                                  setApplicantData({
                                    Local_Govt_Area: event.target.value,
                                  })
                                }
                              >
                                <option value="">Select LGA</option>
                                {localGovernments.map((lga) => (
                                  <option key={lga} value={lga}>
                                    {lga}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                          <div className="fx-cl spacem">
                            <label htmlFor="text">Marital Status:</label>
                            <div className="fx-ac space1 regInputCont">
                              <select
                                name="marital_status"
                                value={applicantData.Marital_status}
                                onChange={(event) =>
                                  setApplicantData({
                                    Marital_status: event.target.value,
                                  })
                                }
                              >
                                <option value="">Select option</option>
                                <option value="Single">Single</option>
                                <option value="Married">Married</option>
                                <option value="Divorce">Divorce</option>
                                <option value="Widow">Widow</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="fx-cl spacem regFormfloat">
                          <label className="inputCont" htmlFor="text">
                            Residential address:
                          </label>
                          <div className="fx-ac space1 regInputCont">
                            <textarea
                              name="home_address"
                              id=""
                              cols="30"
                              rows="10"
                              value={applicantData.Residential_address}
                              onChange={(event) =>
                                setApplicantData({
                                  Residential_address: event.target.value,
                                })
                              }
                            ></textarea>
                          </div>
                        </div>
                      </div>
                      <div className="fx-cl space3 regformSect">
                        <div className="tag">
                          <span>O-Level Result:</span>
                        </div>
                        <div className="fx-ac spacem no_of_sitting">
                          <label htmlFor="Number of sittings">
                            Number of sittings:
                          </label>
                          <select
                            name="no_of_sitting"
                            id=""
                            value={applicantData.No__of_sitting}
                            onChange={(event) =>
                              setApplicantData({
                                No__of_sitting: event.target.value,
                              })
                            }
                          >
                            <option value="1">1</option>
                            <option value="2">2</option>
                          </select>
                        </div>
                        <div className="g g2 space4 rwdG2RegformResultCont">
                          <div className="resultsCont  fx-cl space3">
                            <div className="ExamsCenterInfo space1 rwdG3">
                              <div className="fx-cl spacem regFormfloat">
                                <label className="inputCont" htmlFor="text">
                                  Center name:
                                </label>
                                <div className="fx-ac space1 regInputCont">
                                  <input
                                    type="text"
                                    name="first_sitting_center_name"
                                    value={applicantData.fcenter_name}
                                    onChange={(event) =>
                                      setApplicantData({
                                        fcenter_name: event.target.value,
                                      })
                                    }
                                  />
                                </div>
                              </div>
                              <div className="fx-cl spacem regFormfloat">
                                <label className="inputCont" htmlFor="text">
                                  Center No.:
                                </label>
                                <div className="fx-ac space1 regInputCont">
                                  <input
                                    type="text"
                                    name="first_sitting_center_number"
                                    value={applicantData.fcenter_number}
                                    onChange={(event) =>
                                      setApplicantData({
                                        fcenter_number: event.target.value,
                                      })
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="ExamsCenterInfoB space1 rwdG3">
                              <div className="fx-cl spacem regFormfloat">
                                <label className="inputCont" htmlFor="text">
                                  Exam No.:
                                </label>
                                <div className="fx-ac space1 regInputCont">
                                  <input
                                    type="text"
                                    name="first_sitting_exam_number"
                                    value={applicantData.fexams_number}
                                    onChange={(event) =>
                                      setApplicantData({
                                        fexams_number: event.target.value,
                                      })
                                    }
                                  />
                                </div>
                              </div>
                              <div className="fx-cl spacem regFormfloat">
                                <label className="inputCont" htmlFor="text">
                                  Exam type:
                                </label>
                                <div className="fx-ac space1 regInputCont">
                                  <select
                                    name="first_sitting_exam_type"
                                    id=""
                                    value={applicantData.fexams_type}
                                    onChange={(event) =>
                                      setApplicantData({
                                        fexams_type: event.target.value,
                                      })
                                    }
                                  >
                                    <option value="" hidden>
                                      Select exam type
                                    </option>
                                    <option value="NABTEB">NABTEB</option>
                                    <option value="NECO">NECO</option>
                                    <option value="WAEC">WAEC</option>
                                  </select>
                                </div>
                              </div>
                              <div className="fx-cl spacem regFormfloat">
                                <label className="inputCont" htmlFor="text">
                                  Exam year:
                                </label>
                                <div className="fx-ac space1 regInputCont">
                                  <select
                                    name="first_sitting_exam_year"
                                    id=""
                                    value={applicantData.fexams_year}
                                    onChange={(event) =>
                                      setApplicantData({
                                        fexams_year: event.target.value,
                                      })
                                    }
                                  >
                                    <option value="" hidden>
                                      Select Year
                                    </option>
                                    <option value="2026">2026</option>
                                    <option value="2025">2025</option>
                                    <option value="2024">2024</option>
                                    <option value="2023">2023</option>
                                    <option value="2022">2022</option>
                                    <option value="2021">2021</option>
                                    <option value="2020">2020</option>
                                    <option value="2019">2019</option>
                                    <option value="2018">2018</option>
                                    <option value="2017">2017</option>
                                    <option value="2016">2016</option>
                                    <option value="2015">2015</option>
                                    <option value="2014">2014</option>
                                    <option value="2013">2013</option>
                                    <option value="2012">2012</option>
                                    <option value="2011">2011</option>
                                    <option value="2010">2010</option>
                                    <option value="2009">2009</option>
                                    <option value="2008">2008</option>
                                    <option value="2007">2007</option>
                                    <option value="2006">2006</option>
                                    <option value="2005">2005</option>
                                    <option value="2004">2004</option>
                                    <option value="2003">2003</option>
                                    <option value="2002">2002</option>
                                    <option value="2001">2001</option>
                                    <option value="2000">2000</option>
                                    <option value="1999">1999</option>
                                    <option value="1998">1998</option>
                                    <option value="1997">1997</option>
                                    <option value="1996">1996</option>
                                    <option value="1995">1995</option>
                                    <option value="1994">1994</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                            {/* FIRST SITTING RESULTS MARKUPS */}
                            <div className="gradeSelection fx-cl space2">
                              <div className="fx-ac space1 regformScoreRwd">
                                <span>1</span>
                                <div className="fx-ac space1 regInputCont">
                                  <select
                                    name="fcourse1"
                                    id=""
                                    value={applicantData.fcourse1}
                                    onChange={(event) =>
                                      setApplicantData({
                                        fcourse1: event.target.value,
                                      })
                                    }
                                  >
                                    {/* <option value="" hidden>
                                    Subject:
                                  </option> */}
                                    <option value="Mathematics" selected>
                                      Mathematics
                                    </option>
                                    {/* <option value="English Language">
                                    English Language
                                  </option>
                                  <option value="Biology">Biology</option>
                                  <option value="Physics">Physics</option>
                                  <option value="Chemistry">Chemistry</option>
                                  <option value="Geography">Geography</option>
                                  <option value="Economics">Economics</option>
                                  <option value="Government">Government</option>
                                  <option value="Literature">Literature</option>
                                  <option value="Agricultural Science">
                                    Agricultural Science
                                  </option> */}
                                  </select>
                                </div>
                                <div className="fx-ac space1 regInputCont">
                                  <select
                                    name="fscore1"
                                    id=""
                                    value={applicantData.fscore1}
                                    onChange={(event) =>
                                      setApplicantData({
                                        fscore1: event.target.value,
                                      })
                                    }
                                  >
                                    <option value="" hidden>
                                      Grade:
                                    </option>
                                    <option value="A">A1</option>
                                    <option value="B2">B2</option>
                                    <option value="B3">B3</option>
                                    <option value="C4">C4</option>
                                    <option value="C5">C5</option>
                                    <option value="C6">C6</option>
                                    <option value="D7">D7</option>
                                    <option value="E8">E8</option>
                                    <option value="F9">F9</option>
                                  </select>
                                </div>
                              </div>
                              <div className="fx-ac space1 regformScoreRwd">
                                <span>2</span>
                                <div className="fx-ac space1 regInputCont">
                                  <select
                                    name="fcourse2"
                                    id=""
                                    value={applicantData.fcourse2}
                                    onChange={(event) =>
                                      setApplicantData({
                                        fcourse2: event.target.value,
                                      })
                                    }
                                  >
                                    <option value="" hidden>
                                      Subject:
                                    </option>
                                    {/* <option value="Mathematics">
                                    Mathematics
                                  </option> */}
                                    <option value="English Language" selected>
                                      English Language
                                    </option>
                                    {/* <option value="Biology">Biology</option>
                                  <option value="Physics">Physics</option>
                                  <option value="Chemistry">Chemistry</option>
                                  <option value="Geography">Geography</option>
                                  <option value="Economics">Economics</option>
                                  <option value="Government">Government</option>
                                  <option value="Literature">Literature</option>
                                  <option value="Agricultural Science">
                                    Agricultural Science
                                  </option> */}
                                  </select>
                                </div>
                                <div className="fx-ac space1 regInputCont">
                                  <select
                                    name="fscore2"
                                    id=""
                                    value={applicantData.fscore2}
                                    onChange={(event) =>
                                      setApplicantData({
                                        fscore2: event.target.value,
                                      })
                                    }
                                  >
                                    <option value="" hidden>
                                      Grade:
                                    </option>
                                    <option value="A">A1</option>
                                    <option value="B2">B2</option>
                                    <option value="B3">B3</option>
                                    <option value="C4">C4</option>
                                    <option value="C5">C5</option>
                                    <option value="C6">C6</option>
                                    <option value="D7">D7</option>
                                    <option value="E8">E8</option>
                                    <option value="F9">F9</option>
                                  </select>
                                </div>
                              </div>
                              <div className="fx-ac space1 regformScoreRwd">
                                <span>3</span>
                                <div className="fx-ac space1 regInputCont">
                                  <select
                                    name="fcourse3"
                                    id=""
                                    value={applicantData.fcourse3}
                                    onChange={(event) =>
                                      setApplicantData({
                                        fcourse3: event.target.value,
                                      })
                                    }
                                  >
                                    {/* <option value="" hidden>
                                    Subject:
                                  </option>
                                  <option value="Mathematics">
                                    Mathematics
                                  </option>
                                  <option value="English Language">
                                    English Language
                                  </option> */}
                                    <option value="Biology" selected>
                                      Biology
                                    </option>
                                    {/* <option value="Physics">Physics</option>
                                  <option value="Chemistry">Chemistry</option>
                                  <option value="Geography">Geography</option>
                                  <option value="Economics">Economics</option>
                                  <option value="Government">Government</option>
                                  <option value="Literature">Literature</option>
                                  <option value="Agricultural Science">
                                    Agricultural Science
                                  </option> */}
                                  </select>
                                </div>
                                <div className="fx-ac space1 regInputCont">
                                  <select
                                    name="fscore3"
                                    id=""
                                    value={applicantData.fscore3}
                                    onChange={(event) =>
                                      setApplicantData({
                                        fscore3: event.target.value,
                                      })
                                    }
                                  >
                                    <option value="" hidden>
                                      Grade:
                                    </option>
                                    <option value="A">A1</option>
                                    <option value="B2">B2</option>
                                    <option value="B3">B3</option>
                                    <option value="C4">C4</option>
                                    <option value="C5">C5</option>
                                    <option value="C6">C6</option>
                                    <option value="D7">D7</option>
                                    <option value="E8">E8</option>
                                    <option value="F9">F9</option>
                                  </select>
                                </div>
                              </div>
                              <div className="fx-ac space1 regformScoreRwd">
                                <span>4</span>
                                <div className="fx-ac space1 regInputCont">
                                  <select
                                    name="fcourse4"
                                    id=""
                                    value={applicantData.fcourse4}
                                    onChange={(event) =>
                                      setApplicantData({
                                        fcourse4: event.target.value,
                                      })
                                    }
                                  >
                                    {/* <option value="" hidden>
                                    Subject:
                                  </option>
                                  <option value="Mathematics">
                                    Mathematics
                                  </option>
                                  <option value="English Language">
                                    English Language
                                  </option>
                                  <option value="Biology">Biology</option> */}
                                    <option value="Physics" selected>
                                      Physics
                                    </option>
                                    {/* <option value="Chemistry">Chemistry</option>
                                  <option value="Geography">Geography</option>
                                  <option value="Economics">Economics</option>
                                  <option value="Government">Government</option>
                                  <option value="Literature">Literature</option>
                                  <option value="Agricultural Science">
                                    Agricultural Science
                                  </option> */}
                                  </select>
                                </div>
                                <div className="fx-ac space1 regInputCont">
                                  <select
                                    name="fscore4"
                                    id=""
                                    value={applicantData.fscore4}
                                    onChange={(event) =>
                                      setApplicantData({
                                        fscore4: event.target.value,
                                      })
                                    }
                                  >
                                    <option value="" hidden>
                                      Grade:
                                    </option>
                                    <option value="A">A1</option>
                                    <option value="B2">B2</option>
                                    <option value="B3">B3</option>
                                    <option value="C4">C4</option>
                                    <option value="C5">C5</option>
                                    <option value="C6">C6</option>
                                    <option value="D7">D7</option>
                                    <option value="E8">E8</option>
                                    <option value="F9">F9</option>
                                  </select>
                                </div>
                              </div>
                              <div className="fx-ac space1 regformScoreRwd">
                                <span>5</span>
                                <div className="fx-ac space1 regInputCont">
                                  <select
                                    name="fcourse5"
                                    id=""
                                    value={applicantData.fcourse5}
                                    onChange={(event) =>
                                      setApplicantData({
                                        fcourse5: event.target.value,
                                      })
                                    }
                                  >
                                    {/* <option value="" hidden>
                                    Subject:
                                  </option>
                                  <option value="Mathematics">
                                    Mathematics
                                  </option>
                                  <option value="English Language">
                                    English Language
                                  </option>
                                  <option value="Biology">Biology</option>
                                  <option value="Physics">Physics</option> */}
                                    <option value="Chemistry" selected>
                                      Chemistry
                                    </option>
                                    {/* <option value="Geography">Geography</option>
                                  <option value="Economics">Economics</option>
                                  <option value="Government">Government</option>
                                  <option value="Literature">Literature</option>
                                  <option value="Agricultural Science">
                                    Agricultural Science
                                  </option> */}
                                  </select>
                                </div>
                                <div className="fx-ac space1 regInputCont">
                                  <select
                                    name="fscore5"
                                    id=""
                                    value={applicantData.fscore5}
                                    onChange={(event) =>
                                      setApplicantData({
                                        fscore5: event.target.value,
                                      })
                                    }
                                  >
                                    <option value="" hidden>
                                      Grade:
                                    </option>
                                    <option value="A">A1</option>
                                    <option value="B2">B2</option>
                                    <option value="B3">B3</option>
                                    <option value="C4">C4</option>
                                    <option value="C5">C5</option>
                                    <option value="C6">C6</option>
                                    <option value="D7">D7</option>
                                    <option value="E8">E8</option>
                                    <option value="F9">F9</option>
                                  </select>
                                </div>
                              </div>
                              <div className="fx-ac space1 regformScoreRwd">
                                <span>6</span>
                                <div className="fx-ac space1 regInputCont">
                                  <select
                                    name="fcourse6"
                                    id=""
                                    value={applicantData.fcourse6}
                                    onChange={(event) =>
                                      setApplicantData({
                                        fcourse6: event.target.value,
                                      })
                                    }
                                  >
                                    <option value="" hidden>
                                      Subject:
                                    </option>
                                    {/* <option value="Mathematics">
                                    Mathematics
                                  </option>
                                  <option value="English Language">
                                    English Language
                                  </option>
                                  <option value="Biology">Biology</option>
                                  <option value="Physics">Physics</option>
                                  <option value="Chemistry">Chemistry</option> */}
                                    <option value="Islamic studies">
                                      Islamic studies
                                    </option>
                                    <option value="Animal husbandry">
                                      Animal husbandry
                                    </option>
                                    <option value="Computer science">
                                      Computer science
                                    </option>
                                    <option value="Data processing">
                                      Data processing
                                    </option>
                                    <option value="Economics">Economics</option>
                                    <option value="CRK">CRK</option>
                                    <option value="Civic education">
                                      Civic education
                                    </option>
                                    <option value="Agricultural Science">
                                      Agricultural Science
                                    </option>
                                  </select>
                                </div>
                                <div className="fx-ac space1 regInputCont">
                                  <select
                                    name="fscore6"
                                    id=""
                                    value={applicantData.fscore6}
                                    onChange={(event) =>
                                      setApplicantData({
                                        fscore6: event.target.value,
                                      })
                                    }
                                  >
                                    <option value="" hidden>
                                      Grade:
                                    </option>
                                    <option value="A">A1</option>
                                    <option value="B2">B2</option>
                                    <option value="B3">B3</option>
                                    <option value="C4">C4</option>
                                    <option value="C5">C5</option>
                                    <option value="C6">C6</option>
                                    <option value="D7">D7</option>
                                    <option value="E8">E8</option>
                                    <option value="F9">F9</option>
                                  </select>
                                </div>
                              </div>
                              <div className="fx-ac space1 regformScoreRwd">
                                <span>7</span>
                                <div className="fx-ac space1 regInputCont">
                                  <select
                                    name="fcourse7"
                                    id=""
                                    value={applicantData.fcourse7}
                                    onChange={(event) =>
                                      setApplicantData({
                                        fcourse7: event.target.value,
                                      })
                                    }
                                  >
                                    <option value="" hidden>
                                      Subject:
                                    </option>
                                    {/*<option value="Mathematics">
                                    Mathematics
                                  </option>
                                  <option value="English Language">
                                    English Language
                                  </option>
                                  <option value="Biology">Biology</option>
                                  <option value="Physics">Physics</option>
                                  <option value="Chemistry">Chemistry</option> */}
                                    <option value="Islamic studies">
                                      Islamic studies
                                    </option>
                                    <option value="Animal husbandry">
                                      Animal husbandry
                                    </option>
                                    <option value="Computer science">
                                      Computer science
                                    </option>
                                    <option value="Data processing">
                                      Data processing
                                    </option>
                                    <option value="Economics">Economics</option>
                                    <option value="CRK">CRK</option>
                                    <option value="Civic education">
                                      Civic education
                                    </option>
                                    <option value="Agricultural Science">
                                      Agricultural Science
                                    </option>
                                  </select>
                                </div>
                                <div className="fx-ac space1 regInputCont">
                                  <select
                                    name="fscore7"
                                    id=""
                                    value={applicantData.fscore7}
                                    onChange={(event) =>
                                      setApplicantData({
                                        fscore7: event.target.value,
                                      })
                                    }
                                  >
                                    <option value="" hidden>
                                      Grade:
                                    </option>
                                    <option value="A">A1</option>
                                    <option value="B2">B2</option>
                                    <option value="B3">B3</option>
                                    <option value="C4">C4</option>
                                    <option value="C5">C5</option>
                                    <option value="C6">C6</option>
                                    <option value="D7">D7</option>
                                    <option value="E8">E8</option>
                                    <option value="F9">F9</option>
                                  </select>
                                </div>
                              </div>
                              <div className="fx-ac space1 regformScoreRwd">
                                <span>8</span>
                                <div className="fx-ac space1 regInputCont">
                                  <select
                                    name=""
                                    id=""
                                    value={applicantData.fcourse8}
                                    onChange={(event) =>
                                      setApplicantData({
                                        fcourse8: event.target.value,
                                      })
                                    }
                                  >
                                    <option value="" hidden>
                                      Subject:
                                    </option>
                                    {/* <option value="Mathematics">
                                    Mathematics
                                  </option>
                                  <option value="English Language">
                                    English Language
                                  </option>
                                  <option value="Biology">Biology</option>
                                  <option value="Physics">Physics</option>
                                  <option value="Chemistry">Chemistry</option> */}
                                    <option value="Islamic studies">
                                      Islamic studies
                                    </option>
                                    <option value="Animal husbandry">
                                      Animal husbandry
                                    </option>
                                    <option value="Computer science">
                                      Computer science
                                    </option>
                                    <option value="Data processing">
                                      Data processing
                                    </option>
                                    <option value="Economics">Economics</option>
                                    <option value="CRK">CRK</option>
                                    <option value="Civic education">
                                      Civic education
                                    </option>
                                    <option value="Agricultural Science">
                                      Agricultural Science
                                    </option>
                                  </select>
                                </div>
                                <div className="fx-ac space1 regInputCont">
                                  <select
                                    name="fscore8"
                                    id=""
                                    value={applicantData.fscore8}
                                    onChange={(event) =>
                                      setApplicantData({
                                        fscore8: event.target.value,
                                      })
                                    }
                                  >
                                    <option value="" hidden>
                                      Grade:
                                    </option>
                                    <option value="A">A1</option>
                                    <option value="B2">B2</option>
                                    <option value="B3">B3</option>
                                    <option value="C4">C4</option>
                                    <option value="C5">C5</option>
                                    <option value="C6">C6</option>
                                    <option value="D7">D7</option>
                                    <option value="E8">E8</option>
                                    <option value="F9">F9</option>
                                  </select>
                                </div>
                              </div>
                              <div className="fx-ac space1 regformScoreRwd">
                                <span>9</span>
                                <div className="fx-ac space1 regInputCont">
                                  <select
                                    name="fcourse9"
                                    id=""
                                    value={applicantData.fcourse9}
                                    onChange={(event) =>
                                      setApplicantData({
                                        fcourse9: event.target.value,
                                      })
                                    }
                                  >
                                    <option value="" hidden>
                                      Subject:
                                    </option>
                                    {/* <option value="Mathematics">
                                    Mathematics
                                  </option>
                                  <option value="English Language">
                                    English Language
                                  </option>
                                  <option value="Biology">Biology</option>
                                  <option value="Physics">Physics</option>
                                  <option value="Chemistry">Chemistry</option> */}
                                    <option value="Islamic studies">
                                      Islamic studies
                                    </option>
                                    <option value="Animal husbandry">
                                      Animal husbandry
                                    </option>
                                    <option value="Computer science">
                                      Computer science
                                    </option>
                                    <option value="Data processing">
                                      Data processing
                                    </option>
                                    <option value="Economics">Economics</option>
                                    <option value="CRK">CRK</option>
                                    <option value="Civic education">
                                      Civic education
                                    </option>
                                    <option value="Agricultural Science">
                                      Agricultural Science
                                    </option>
                                  </select>
                                </div>
                                <div className="fx-ac space1 regInputCont">
                                  <select
                                    name="fscore9"
                                    id=""
                                    value={applicantData.fscore9}
                                    onChange={(event) =>
                                      setApplicantData({
                                        fscore9: event.target.value,
                                      })
                                    }
                                  >
                                    <option value="" hidden>
                                      Grade:
                                    </option>
                                    <option value="A">A1</option>
                                    <option value="B2">B2</option>
                                    <option value="B3">B3</option>
                                    <option value="C4">C4</option>
                                    <option value="C5">C5</option>
                                    <option value="C6">C6</option>
                                    <option value="D7">D7</option>
                                    <option value="E8">E8</option>
                                    <option value="F9">F9</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                          </div>
                          {applicantData.No__of_sitting === "2" ? (
                            <div className="resultsCont  fx-cl space3">
                              {/* SECOND SITTING RESULTS MARKUPS */}
                              <div className="ExamsCenterInfo space1 rwdG3">
                                <div className="fx-cl spacem regFormfloat">
                                  <label className="inputCont" htmlFor="text">
                                    Center name:
                                  </label>
                                  <div className="fx-ac space1 regInputCont">
                                    <input
                                      type="text"
                                      name="ssitting_center_name"
                                      value={applicantData.scenter_name}
                                      onChange={(event) =>
                                        setApplicantData({
                                          scenter_name: event.target.value,
                                        })
                                      }
                                    />
                                  </div>
                                </div>
                                <div className="fx-cl spacem regFormfloat">
                                  <label className="inputCont" htmlFor="text">
                                    Center No.:
                                  </label>
                                  <div className="fx-ac space1 regInputCont">
                                    <input
                                      type="text"
                                      name="ssitting_center_number"
                                      value={applicantData.scenter_number}
                                      onChange={(event) =>
                                        setApplicantData({
                                          scenter_number: event.target.value,
                                        })
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="ExamsCenterInfoB space1 rwdG3">
                                <div className="fx-cl spacem regFormfloat">
                                  <label className="inputCont" htmlFor="text">
                                    Exam No.:
                                  </label>
                                  <div className="fx-ac space1 regInputCont">
                                    <input
                                      type="text"
                                      name="ssitting_exam_number"
                                      value={applicantData.sexams_number}
                                      onChange={(event) =>
                                        setApplicantData({
                                          sexams_number: event.target.value,
                                        })
                                      }
                                    />
                                  </div>
                                </div>
                                <div className="fx-cl spacem regFormfloat">
                                  <label className="inputCont" htmlFor="text">
                                    Exam type:
                                  </label>
                                  <div className="fx-ac space1 regInputCont">
                                    <select
                                      name="ssitting_exams_type"
                                      id=""
                                      value={applicantData.sexams_type}
                                      onChange={(event) =>
                                        setApplicantData({
                                          sexams_type: event.target.value,
                                        })
                                      }
                                    >
                                      <option value="" hidden>
                                        Select exam type
                                      </option>
                                      <option value="NABTEB">NABTEB</option>
                                      <option value="NECO">NECO</option>
                                      <option value="WAEC">WAEC</option>
                                    </select>
                                  </div>
                                </div>
                                <div className="fx-cl spacem regFormfloat">
                                  <label className="inputCont" htmlFor="text">
                                    Exam year:
                                  </label>
                                  <div className="fx-ac space1 regInputCont">
                                    <select
                                      name="ssitting_exam_year"
                                      id=""
                                      value={applicantData.sexams_year}
                                      onChange={(event) =>
                                        setApplicantData({
                                          sexams_year: event.target.value,
                                        })
                                      }
                                    >
                                      <option value="" hidden>
                                        Select Year
                                      </option>
                                      <option value="2026">2026</option>
                                      <option value="2025">2025</option>
                                      <option value="2024">2024</option>
                                      <option value="2023">2023</option>
                                      <option value="2022">2022</option>
                                      <option value="2021">2021</option>
                                      <option value="2020">2020</option>
                                      <option value="2019">2019</option>
                                      <option value="2018">2018</option>
                                      <option value="2017">2017</option>
                                      <option value="2016">2016</option>
                                      <option value="2015">2015</option>
                                      <option value="2014">2014</option>
                                      <option value="2013">2013</option>
                                      <option value="2012">2012</option>
                                      <option value="2011">2011</option>
                                      <option value="2010">2010</option>
                                      <option value="2009">2009</option>
                                      <option value="2008">2008</option>
                                      <option value="2007">2007</option>
                                      <option value="2006">2006</option>
                                      <option value="2005">2005</option>
                                      <option value="2004">2004</option>
                                      <option value="2003">2003</option>
                                      <option value="2002">2002</option>
                                      <option value="2001">2001</option>
                                      <option value="2000">2000</option>
                                      <option value="1999">1999</option>
                                      <option value="1998">1998</option>
                                      <option value="1997">1997</option>
                                      <option value="1996">1996</option>
                                      <option value="1995">1995</option>
                                      <option value="1994">1994</option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                              <div className="gradeSelection fx-cl space2">
                                <div className="fx-ac space1 regformScoreRwd">
                                  <span>1</span>
                                  <div className="fx-ac space1 regInputCont">
                                    <select
                                      name="scourse1"
                                      id=""
                                      value={applicantData.scourse1}
                                      onChange={(event) =>
                                        setApplicantData({
                                          scourse1: event.target.value,
                                        })
                                      }
                                    >
                                      {/* <option value="" hidden>
                                        Subject:
                                      </option> */}
                                      <option value="Mathematics" selected>
                                        Mathematics
                                      </option>
                                      {/* <option value="English Language">
                                        English Language
                                      </option>
                                      <option value="Biology">Biology</option>
                                      <option value="Physics">Physics</option>
                                      <option value="Chemistry">
                                        Chemistry
                                      </option>
                                      <option value="Geography">
                                        Geography
                                      </option>
                                      <option value="Economics">
                                        Economics
                                      </option>
                                      <option value="Government">
                                        Government
                                      </option>
                                      <option value="Literature">
                                        Literature
                                      </option>
                                      <option value="Agricultural Science">
                                        Agricultural Science
                                      </option> */}
                                    </select>
                                  </div>
                                  <div className="fx-ac space1 regInputCont">
                                    <select
                                      name="sscore1"
                                      id=""
                                      value={applicantData.sscore1}
                                      onChange={(event) =>
                                        setApplicantData({
                                          sscore1: event.target.value,
                                        })
                                      }
                                    >
                                      <option value="" hidden>
                                        Grade:
                                      </option>
                                      <option value="A">A1</option>
                                      <option value="B2">B2</option>
                                      <option value="B3">B3</option>
                                      <option value="C4">C4</option>
                                      <option value="C5">C5</option>
                                      <option value="C6">C6</option>
                                      <option value="D7">D7</option>
                                      <option value="E8">E8</option>
                                      <option value="F9">F9</option>
                                    </select>
                                  </div>
                                </div>
                                <div className="fx-ac space1 regformScoreRwd">
                                  <span>2</span>
                                  <div className="fx-ac space1 regInputCont">
                                    <select
                                      name="scourse2"
                                      id=""
                                      value={applicantData.scourse2}
                                      onChange={(event) =>
                                        setApplicantData({
                                          scourse2: event.target.value,
                                        })
                                      }
                                    >
                                      {/* <option value="" hidden>
                                      Subject:
                                    </option>
                                    <option value="Mathematics">
                                      Mathematics
                                    </option> */}
                                      <option value="English Language" selected>
                                        English Language
                                      </option>
                                      {/* <option value="Biology">Biology</option>
                                    <option value="Physics">Physics</option>
                                    <option value="Chemistry">Chemistry</option>
                                    <option value="Geography">Geography</option>
                                    <option value="Economics">Economics</option>
                                    <option value="Government">
                                      Government
                                    </option>
                                    <option value="Literature">
                                      Literature
                                    </option>
                                    <option value="Agricultural Science">
                                      Agricultural Science
                                    </option> */}
                                    </select>
                                  </div>
                                  <div className="fx-ac space1 regInputCont">
                                    <select
                                      name="sscore2"
                                      id=""
                                      value={applicantData.sscore2}
                                      onChange={(event) =>
                                        setApplicantData({
                                          sscore2: event.target.value,
                                        })
                                      }
                                    >
                                      <option value="" hidden>
                                        Grade:
                                      </option>
                                      <option value="A">A1</option>
                                      <option value="B2">B2</option>
                                      <option value="B3">B3</option>
                                      <option value="C4">C4</option>
                                      <option value="C5">C5</option>
                                      <option value="C6">C6</option>
                                      <option value="D7">D7</option>
                                      <option value="E8">E8</option>
                                      <option value="F9">F9</option>
                                    </select>
                                  </div>
                                </div>
                                <div className="fx-ac space1 regformScoreRwd">
                                  <span>3</span>
                                  <div className="fx-ac space1 regInputCont">
                                    <select
                                      name="scourse3"
                                      id=""
                                      value={applicantData.scourse3}
                                      onChange={(event) =>
                                        setApplicantData({
                                          scourse3: event.target.value,
                                        })
                                      }
                                    >
                                      {/* <option value="" hidden>
                                      Subject:
                                    </option>
                                    <option value="Mathematics">
                                      Mathematics
                                    </option>
                                    <option value="English Language">
                                      English Language
                                    </option> */}
                                      <option value="Biology" selected>
                                        Biology
                                      </option>
                                      {/* <option value="Physics">Physics</option>
                                    <option value="Chemistry">Chemistry</option>
                                    <option value="Geography">Geography</option>
                                    <option value="Economics">Economics</option>
                                    <option value="Government">
                                      Government
                                    </option>
                                    <option value="Literature">
                                      Literature
                                    </option>
                                    <option value="Agricultural Science">
                                      Agricultural Science
                                    </option> */}
                                    </select>
                                  </div>
                                  <div className="fx-ac space1 regInputCont">
                                    <select
                                      name="sscore3"
                                      id=""
                                      value={applicantData.sscore3}
                                      onChange={(event) =>
                                        setApplicantData({
                                          sscore3: event.target.value,
                                        })
                                      }
                                    >
                                      <option value="" hidden>
                                        Grade:
                                      </option>
                                      <option value="A">A1</option>
                                      <option value="B2">B2</option>
                                      <option value="B3">B3</option>
                                      <option value="C4">C4</option>
                                      <option value="C5">C5</option>
                                      <option value="C6">C6</option>
                                      <option value="D7">D7</option>
                                      <option value="E8">E8</option>
                                      <option value="F9">F9</option>
                                    </select>
                                  </div>
                                </div>
                                <div className="fx-ac space1 regformScoreRwd">
                                  <span>4</span>
                                  <div className="fx-ac space1 regInputCont">
                                    <select
                                      name="scourse4"
                                      id=""
                                      value={applicantData.scourse4}
                                      onChange={(event) =>
                                        setApplicantData({
                                          scourse4: event.target.value,
                                        })
                                      }
                                    >
                                      {/* <option value="" hidden>
                                      Subject:
                                    </option>
                                    <option value="Mathematics">
                                      Mathematics
                                    </option>
                                    <option value="English Language">
                                      English Language
                                    </option>
                                    <option value="Biology">Biology</option> */}
                                      <option value="Physics" selected>
                                        Physics
                                      </option>
                                      {/* <option value="Chemistry">Chemistry</option>
                                    <option value="Geography">Geography</option>
                                    <option value="Economics">Economics</option>
                                    <option value="Government">
                                      Government
                                    </option>
                                    <option value="Literature">
                                      Literature
                                    </option>
                                    <option value="Agricultural Science">
                                      Agricultural Science
                                    </option> */}
                                    </select>
                                  </div>
                                  <div className="fx-ac space1 regInputCont">
                                    <select
                                      name="sscore4"
                                      id=""
                                      value={applicantData.sscore4}
                                      onChange={(event) =>
                                        setApplicantData({
                                          sscore4: event.target.value,
                                        })
                                      }
                                    >
                                      <option value="" hidden>
                                        Grade:
                                      </option>
                                      <option value="A">A1</option>
                                      <option value="B2">B2</option>
                                      <option value="B3">B3</option>
                                      <option value="C4">C4</option>
                                      <option value="C5">C5</option>
                                      <option value="C6">C6</option>
                                      <option value="D7">D7</option>
                                      <option value="E8">E8</option>
                                      <option value="F9">F9</option>
                                    </select>
                                  </div>
                                </div>
                                <div className="fx-ac space1 regformScoreRwd">
                                  <span>5</span>
                                  <div className="fx-ac space1 regInputCont">
                                    <select
                                      name="scourse5"
                                      id=""
                                      value={applicantData.scourse5}
                                      onChange={(event) =>
                                        setApplicantData({
                                          scourse5: event.target.value,
                                        })
                                      }
                                    >
                                      {/* <option value="" hidden>
                                      Subject:
                                    </option>
                                    <option value="Mathematics">
                                      Mathematics
                                    </option>
                                    <option value="English Language">
                                      English Language
                                    </option>
                                    <option value="Biology">Biology</option>
                                    <option value="Physics">Physics</option> */}
                                      <option value="Chemistry" selected>
                                        Chemistry
                                      </option>
                                      {/* <option value="Geography">Geography</option>
                                    <option value="Economics">Economics</option>
                                    <option value="Government">
                                      Government
                                    </option>
                                    <option value="Literature">
                                      Literature
                                    </option>
                                    <option value="Agricultural Science">
                                      Agricultural Science
                                    </option> */}
                                    </select>
                                  </div>
                                  <div className="fx-ac space1 regInputCont">
                                    <select
                                      name="sscore5"
                                      id=""
                                      value={applicantData.sscore5}
                                      onChange={(event) =>
                                        setApplicantData({
                                          sscore5: event.target.value,
                                        })
                                      }
                                    >
                                      <option value="" hidden>
                                        Grade:
                                      </option>
                                      <option value="A">A1</option>
                                      <option value="B2">B2</option>
                                      <option value="B3">B3</option>
                                      <option value="C4">C4</option>
                                      <option value="C5">C5</option>
                                      <option value="C6">C6</option>
                                      <option value="D7">D7</option>
                                      <option value="E8">E8</option>
                                      <option value="F9">F9</option>
                                    </select>
                                  </div>
                                </div>
                                <div className="fx-ac space1 regformScoreRwd">
                                  <span>6</span>
                                  <div className="fx-ac space1 regInputCont">
                                    <select
                                      name="scourse6"
                                      id=""
                                      value={applicantData.scourse6}
                                      onChange={(event) =>
                                        setApplicantData({
                                          scourse6: event.target.value,
                                        })
                                      }
                                    >
                                      <option value="" hidden>
                                        Subject:
                                      </option>
                                      {/*<option value="Mathematics">
                                      Mathematics
                                    </option>
                                    <option value="English Language">
                                      English Language
                                    </option>
                                    <option value="Biology">Biology</option>
                                    <option value="Physics">Physics</option>
                                    <option value="Chemistry">Chemistry</option> */}
                                      <option value="Islamic studies">
                                        Islamic studies
                                      </option>
                                      <option value="Animal husbandry">
                                        Animal husbandry
                                      </option>
                                      <option value="Computer science">
                                        Computer science
                                      </option>
                                      <option value="Data processing">
                                        Data processing
                                      </option>
                                      <option value="Economics">
                                        Economics
                                      </option>
                                      <option value="CRK">CRK</option>
                                      <option value="Civic education">
                                        Civic education
                                      </option>
                                      <option value="Agricultural Science">
                                        Agricultural Science
                                      </option>
                                    </select>
                                  </div>
                                  <div className="fx-ac space1 regInputCont">
                                    <select
                                      name="sscore6"
                                      id=""
                                      value={applicantData.sscore6}
                                      onChange={(event) =>
                                        setApplicantData({
                                          sscore6: event.target.value,
                                        })
                                      }
                                    >
                                      <option value="" hidden>
                                        Grade:
                                      </option>
                                      <option value="A">A1</option>
                                      <option value="B2">B2</option>
                                      <option value="B3">B3</option>
                                      <option value="C4">C4</option>
                                      <option value="C5">C5</option>
                                      <option value="C6">C6</option>
                                      <option value="D7">D7</option>
                                      <option value="E8">E8</option>
                                      <option value="F9">F9</option>
                                    </select>
                                  </div>
                                </div>
                                <div className="fx-ac space1 regformScoreRwd">
                                  <span>7</span>
                                  <div className="fx-ac space1 regInputCont">
                                    <select
                                      name="scourse7"
                                      id=""
                                      value={applicantData.scourse7}
                                      onChange={(event) =>
                                        setApplicantData({
                                          scourse7: event.target.value,
                                        })
                                      }
                                    >
                                      <option value="" hidden>
                                        Subject:
                                      </option>
                                      {/*<option value="Mathematics">
                                      Mathematics
                                    </option>
                                    <option value="English Language">
                                      English Language
                                    </option>
                                    <option value="Biology">Biology</option>
                                    <option value="Physics">Physics</option>
                                    <option value="Chemistry">Chemistry</option> */}
                                      <option value="Islamic studies">
                                        Islamic studies
                                      </option>
                                      <option value="Animal husbandry">
                                        Animal husbandry
                                      </option>
                                      <option value="Computer science">
                                        Computer science
                                      </option>
                                      <option value="Data processing">
                                        Data processing
                                      </option>
                                      <option value="Economics">
                                        Economics
                                      </option>
                                      <option value="CRK">CRK</option>
                                      <option value="Civic education">
                                        Civic education
                                      </option>
                                      <option value="Agricultural Science">
                                        Agricultural Science
                                      </option>
                                    </select>
                                  </div>
                                  <div className="fx-ac space1 regInputCont">
                                    <select
                                      name="sscore7"
                                      id=""
                                      value={applicantData.sscore7}
                                      onChange={(event) =>
                                        setApplicantData({
                                          sscore7: event.target.value,
                                        })
                                      }
                                    >
                                      <option value="" hidden>
                                        Grade:
                                      </option>
                                      <option value="A">A1</option>
                                      <option value="B2">B2</option>
                                      <option value="B3">B3</option>
                                      <option value="C4">C4</option>
                                      <option value="C5">C5</option>
                                      <option value="C6">C6</option>
                                      <option value="D7">D7</option>
                                      <option value="E8">E8</option>
                                      <option value="F9">F9</option>
                                    </select>
                                  </div>
                                </div>
                                <div className="fx-ac space1 regformScoreRwd">
                                  <span>8</span>
                                  <div className="fx-ac space1 regInputCont">
                                    <select
                                      name="scourse8"
                                      id=""
                                      value={applicantData.scourse8}
                                      onChange={(event) =>
                                        setApplicantData({
                                          scourse8: event.target.value,
                                        })
                                      }
                                    >
                                      <option value="" hidden>
                                        Subject:
                                      </option>
                                      {/*<option value="Mathematics">
                                      Mathematics
                                    </option>
                                    <option value="English Language">
                                      English Language
                                    </option>
                                    <option value="Biology">Biology</option>
                                    <option value="Physics">Physics</option>
                                    <option value="Chemistry">Chemistry</option> */}
                                      <option value="Islamic studies">
                                        Islamic studies
                                      </option>
                                      <option value="Animal husbandry">
                                        Animal husbandry
                                      </option>
                                      <option value="Computer science">
                                        Computer science
                                      </option>
                                      <option value="Data processing">
                                        Data processing
                                      </option>
                                      <option value="Economics">
                                        Economics
                                      </option>
                                      <option value="CRK">CRK</option>
                                      <option value="Civic education">
                                        Civic education
                                      </option>
                                      <option value="Agricultural Science">
                                        Agricultural Science
                                      </option>
                                    </select>
                                  </div>
                                  <div className="fx-ac space1 regInputCont">
                                    <select
                                      name="sscore8"
                                      id=""
                                      value={applicantData.sscore8}
                                      onChange={(event) =>
                                        setApplicantData({
                                          sscore8: event.target.value,
                                        })
                                      }
                                    >
                                      <option value="" hidden>
                                        Grade:
                                      </option>
                                      <option value="A">A1</option>
                                      <option value="B2">B2</option>
                                      <option value="B3">B3</option>
                                      <option value="C4">C4</option>
                                      <option value="C5">C5</option>
                                      <option value="C6">C6</option>
                                      <option value="D7">D7</option>
                                      <option value="E8">E8</option>
                                      <option value="F9">F9</option>
                                    </select>
                                  </div>
                                </div>
                                <div className="fx-ac space1 regformScoreRwd">
                                  <span>9</span>
                                  <div className="fx-ac space1 regInputCont">
                                    <select
                                      name="scourse9"
                                      id=""
                                      value={applicantData.scourse9}
                                      onChange={(event) =>
                                        setApplicantData({
                                          scourse9: event.target.value,
                                        })
                                      }
                                    >
                                      <option value="" hidden>
                                        Subject:
                                      </option>
                                      {/*<option value="Mathematics">
                                      Mathematics
                                    </option>
                                    <option value="English Language">
                                      English Language
                                    </option>
                                    <option value="Biology">Biology</option>
                                    <option value="Physics">Physics</option>
                                    <option value="Chemistry">Chemistry</option> */}
                                      <option value="Islamic studies">
                                        Islamic studies
                                      </option>
                                      <option value="Animal husbandry">
                                        Animal husbandry
                                      </option>
                                      <option value="Computer science">
                                        Computer science
                                      </option>
                                      <option value="Data processing">
                                        Data processing
                                      </option>
                                      <option value="Economics">
                                        Economics
                                      </option>
                                      <option value="CRK">CRK</option>
                                      <option value="Civic education">
                                        Civic education
                                      </option>
                                      <option value="Agricultural Science">
                                        Agricultural Science
                                      </option>
                                    </select>
                                  </div>
                                  <div className="fx-ac space1 regInputCont">
                                    <select
                                      name="sscore9"
                                      id=""
                                      value={applicantData.sscore9}
                                      onChange={(event) =>
                                        setApplicantData({
                                          sscore9: event.target.value,
                                        })
                                      }
                                    >
                                      <option value="" hidden>
                                        Grade:
                                      </option>
                                      <option value="A">A1</option>
                                      <option value="B2">B2</option>
                                      <option value="B3">B3</option>
                                      <option value="C4">C4</option>
                                      <option value="C5">C5</option>
                                      <option value="C6">C6</option>
                                      <option value="D7">D7</option>
                                      <option value="E8">E8</option>
                                      <option value="F9">F9</option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ) : (
                            <></>
                          )}
                        </div>
                      </div>
                      <div className="fx-cl space3 regformSect">
                        <div className="tag">
                          <span>Educational Record :</span>
                        </div>
                        <div className="eduRec space1 rwdG4">
                          <div className="fx-cl spacem regFormfloat">
                            <label className="inputCont" htmlFor="text">
                              Primary school attended:
                            </label>
                            <div className="fx-ac space1 regInputCont">
                              <input
                                type="text"
                                name="primary_sch_name"
                                value={applicantData.priName}
                                onChange={(event) =>
                                  setApplicantData({
                                    priName: event.target.value,
                                  })
                                }
                              />
                            </div>
                          </div>
                          <div className="fx-cl spacem regFormfloat">
                            <label className="inputCont" htmlFor="text">
                              From:
                            </label>
                            <div className="fx-ac space1 regInputCont">
                              <select
                                name="primary_sch_started"
                                id=""
                                value={applicantData.priFrom}
                                onChange={(event) =>
                                  setApplicantData({
                                    priFrom: event.target.value,
                                  })
                                }
                              >
                                <option value="" hidden>
                                  Select year started
                                </option>
                                <option value="2024">2024</option>
                                <option value="2023">2023</option>
                                <option value="2022">2022</option>
                                <option value="2021">2021</option>
                                <option value="2020">2020</option>
                                <option value="2019">2019</option>
                                <option value="2018">2018</option>
                                <option value="2017">2017</option>
                                <option value="2016">2016</option>
                                <option value="2015">2015</option>
                                <option value="2014">2014</option>
                                <option value="2013">2013</option>
                                <option value="2012">2012</option>
                                <option value="2011">2011</option>
                                <option value="2010">2010</option>
                                <option value="2009">2009</option>
                                <option value="2008">2008</option>
                                <option value="2007">2007</option>
                                <option value="2006">2006</option>
                                <option value="2005">2005</option>
                                <option value="2004">2004</option>
                                <option value="2003">2003</option>
                                <option value="2002">2002</option>
                                <option value="2001">2001</option>
                                <option value="2000">2000</option>
                                <option value="1999">1999</option>
                                <option value="1998">1998</option>
                                <option value="1997">1997</option>
                                <option value="1996">1996</option>
                                <option value="1995">1995</option>
                                <option value="1994">1994</option>
                                <option value="1994">1993</option>
                                <option value="1994">1992</option>
                                <option value="1994">1991</option>
                                <option value="1994">1990</option>
                                <option value="1994">1989</option>
                                <option value="1994">1988</option>
                                <option value="1994">1987</option>
                                <option value="1994">1986</option>
                                <option value="1994">1985</option>
                                <option value="1994">1984</option>
                                <option value="1994">1983</option>
                                <option value="1994">1982</option>
                                <option value="1994">1981</option>
                                <option value="1994">1980</option>
                                <option value="1994">1979</option>
                                <option value="1994">1978</option>
                                <option value="1994">1977</option>
                                <option value="1994">1976</option>
                                <option value="1994">1975</option>
                                <option value="1994">1974</option>
                                <option value="1994">1973</option>
                                <option value="1994">1972</option>
                                <option value="1994">1971</option>
                                <option value="1994">1970</option>
                                <option value="1994">1969</option>
                                <option value="1994">1968</option>
                                <option value="1994">1967</option>
                                <option value="1994">1966</option>
                                <option value="1994">1965</option>
                                <option value="1994">1964</option>
                                <option value="1994">1963</option>
                                <option value="1994">1962</option>
                                <option value="1994">1961</option>
                                <option value="1994">1960</option>
                              </select>
                            </div>
                          </div>
                          <div className="fx-cl spacem regFormfloat">
                            <label className="inputCont" htmlFor="text">
                              To:
                            </label>
                            <div className="fx-ac space1 regInputCont">
                              <select
                                name="Primary_sch_end"
                                id=""
                                value={applicantData.priTo}
                                onChange={(event) =>
                                  setApplicantData({
                                    priTo: event.target.value,
                                  })
                                }
                              >
                                <option value="" hidden>
                                  Select year end
                                </option>

                                <option value="2026">2026</option>
                                <option value="2025">2025</option>
                                <option value="2023">2023</option>
                                <option value="2022">2022</option>
                                <option value="2021">2021</option>
                                <option value="2020">2020</option>
                                <option value="2019">2019</option>
                                <option value="2018">2018</option>
                                <option value="2017">2017</option>
                                <option value="2016">2016</option>
                                <option value="2015">2015</option>
                                <option value="2014">2014</option>
                                <option value="2013">2013</option>
                                <option value="2012">2012</option>
                                <option value="2011">2011</option>
                                <option value="2010">2010</option>
                                <option value="2009">2009</option>
                                <option value="2008">2008</option>
                                <option value="2007">2007</option>
                                <option value="2006">2006</option>
                                <option value="2005">2005</option>
                                <option value="2004">2004</option>
                                <option value="2003">2003</option>
                                <option value="2002">2002</option>
                                <option value="2001">2001</option>
                                <option value="2000">2000</option>
                                <option value="1999">1999</option>
                                <option value="1998">1998</option>
                                <option value="1997">1997</option>
                                <option value="1996">1996</option>
                                <option value="1995">1995</option>
                                <option value="1994">1994</option>
                                <option value="1994">1993</option>
                                <option value="1994">1992</option>
                                <option value="1994">1991</option>
                                <option value="1994">1990</option>
                                <option value="1994">1989</option>
                                <option value="1994">1988</option>
                                <option value="1994">1987</option>
                                <option value="1994">1986</option>
                                <option value="1994">1985</option>
                                <option value="1994">1984</option>
                                <option value="1994">1983</option>
                                <option value="1994">1982</option>
                                <option value="1994">1981</option>
                                <option value="1994">1980</option>
                                <option value="1994">1979</option>
                                <option value="1994">1978</option>
                                <option value="1994">1977</option>
                                <option value="1994">1976</option>
                                <option value="1994">1975</option>
                                <option value="1994">1974</option>
                                <option value="1994">1973</option>
                                <option value="1994">1972</option>
                                <option value="1994">1971</option>
                                <option value="1994">1970</option>
                                <option value="1994">1969</option>
                                <option value="1994">1968</option>
                                <option value="1994">1967</option>
                                <option value="1994">1966</option>
                                <option value="1994">1965</option>
                                <option value="1994">1964</option>
                                <option value="1994">1963</option>
                                <option value="1994">1962</option>
                                <option value="1994">1961</option>
                                <option value="1994">1960</option>
                              </select>
                            </div>
                          </div>
                          <div className="fx-cl spacem regFormfloat">
                            <label className="inputCont" htmlFor="text">
                              Certificate obtained:
                            </label>
                            <div className="fx-ac space1 regInputCont">
                              <select
                                name="primary_sch_cert"
                                id=""
                                value={applicantData.priCert}
                                onChange={(event) =>
                                  setApplicantData({
                                    priCert: event.target.value,
                                  })
                                }
                              >
                                <option value="" hidden>
                                  Select option
                                </option>
                                <option value="Primary school leaving certificate">
                                  Primary school leaving certificate
                                </option>
                                <option value="JSSLCE">JSSLCE</option>
                                <option value="SSCE">SSCE</option>
                                <option value="WASSCE">WASSCE</option>
                                <option value="NABTEB">NABTEB</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="eduRec space1 rwdG4">
                          <div className="fx-cl spacem regFormfloat">
                            <label className="inputCont" htmlFor="text">
                              Junior Secondary school attended:
                            </label>
                            <div className="fx-ac space1 regInputCont">
                              <input
                                type="text"
                                name="junior_sec_sch_name"
                                value={applicantData.junior_sec_Name}
                                onChange={(event) =>
                                  setApplicantData({
                                    junior_sec_Name: event.target.value,
                                  })
                                }
                              />
                            </div>
                          </div>
                          <div className="fx-cl spacem regFormfloat">
                            <label className="inputCont" htmlFor="text">
                              From:
                            </label>
                            <div className="fx-ac space1 regInputCont">
                              <select
                                name="junior_sec_sch_from"
                                id=""
                                value={applicantData.junior_sec_From}
                                onChange={(event) =>
                                  setApplicantData({
                                    junior_sec_From: event.target.value,
                                  })
                                }
                              >
                                <option value="" hidden>
                                  Select year started
                                </option>
                                <option value="2024">2024</option>
                                <option value="2023">2023</option>
                                <option value="2022">2022</option>
                                <option value="2021">2021</option>
                                <option value="2020">2020</option>
                                <option value="2019">2019</option>
                                <option value="2018">2018</option>
                                <option value="2017">2017</option>
                                <option value="2016">2016</option>
                                <option value="2015">2015</option>
                                <option value="2014">2014</option>
                                <option value="2013">2013</option>
                                <option value="2012">2012</option>
                                <option value="2011">2011</option>
                                <option value="2010">2010</option>
                                <option value="2009">2009</option>
                                <option value="2008">2008</option>
                                <option value="2007">2007</option>
                                <option value="2006">2006</option>
                                <option value="2005">2005</option>
                                <option value="2004">2004</option>
                                <option value="2003">2003</option>
                                <option value="2002">2002</option>
                                <option value="2001">2001</option>
                                <option value="2000">2000</option>
                                <option value="1999">1999</option>
                                <option value="1998">1998</option>
                                <option value="1997">1997</option>
                                <option value="1996">1996</option>
                                <option value="1995">1995</option>
                                <option value="1994">1994</option>
                                <option value="1994">1993</option>
                                <option value="1994">1992</option>
                                <option value="1994">1991</option>
                                <option value="1994">1990</option>
                                <option value="1994">1989</option>
                                <option value="1994">1988</option>
                                <option value="1994">1987</option>
                                <option value="1994">1986</option>
                                <option value="1994">1985</option>
                                <option value="1994">1984</option>
                                <option value="1994">1983</option>
                                <option value="1994">1982</option>
                                <option value="1994">1981</option>
                                <option value="1994">1980</option>
                                <option value="1994">1979</option>
                                <option value="1994">1978</option>
                                <option value="1994">1977</option>
                                <option value="1994">1976</option>
                                <option value="1994">1975</option>
                                <option value="1994">1974</option>
                                <option value="1994">1973</option>
                                <option value="1994">1972</option>
                                <option value="1994">1971</option>
                                <option value="1994">1970</option>
                                <option value="1994">1969</option>
                                <option value="1994">1968</option>
                                <option value="1994">1967</option>
                                <option value="1994">1966</option>
                                <option value="1994">1965</option>
                                <option value="1994">1964</option>
                                <option value="1994">1963</option>
                                <option value="1994">1962</option>
                                <option value="1994">1961</option>
                                <option value="1994">1960</option>
                              </select>
                            </div>
                          </div>
                          <div className="fx-cl spacem regFormfloat">
                            <label className="inputCont" htmlFor="text">
                              To:
                            </label>
                            <div className="fx-ac space1 regInputCont">
                              <select
                                name="junior_sec_sch_end"
                                id=""
                                value={applicantData.junior_sec_To}
                                onChange={(event) =>
                                  setApplicantData({
                                    junior_sec_To: event.target.value,
                                  })
                                }
                              >
                                <option value="" hidden>
                                  Select year end
                                </option>

                                <option value="2026">2026</option>
                                <option value="2025">2025</option>
                                <option value="2024">2024</option>
                                <option value="2023">2023</option>
                                <option value="2022">2022</option>
                                <option value="2021">2021</option>
                                <option value="2020">2020</option>
                                <option value="2019">2019</option>
                                <option value="2018">2018</option>
                                <option value="2017">2017</option>
                                <option value="2016">2016</option>
                                <option value="2015">2015</option>
                                <option value="2014">2014</option>
                                <option value="2013">2013</option>
                                <option value="2012">2012</option>
                                <option value="2011">2011</option>
                                <option value="2010">2010</option>
                                <option value="2009">2009</option>
                                <option value="2008">2008</option>
                                <option value="2007">2007</option>
                                <option value="2006">2006</option>
                                <option value="2005">2005</option>
                                <option value="2004">2004</option>
                                <option value="2003">2003</option>
                                <option value="2002">2002</option>
                                <option value="2001">2001</option>
                                <option value="2000">2000</option>
                                <option value="1999">1999</option>
                                <option value="1998">1998</option>
                                <option value="1997">1997</option>
                                <option value="1996">1996</option>
                                <option value="1995">1995</option>
                                <option value="1994">1994</option>
                                <option value="1994">1993</option>
                                <option value="1994">1992</option>
                                <option value="1994">1991</option>
                                <option value="1994">1990</option>
                                <option value="1994">1989</option>
                                <option value="1994">1988</option>
                                <option value="1994">1987</option>
                                <option value="1994">1986</option>
                                <option value="1994">1985</option>
                                <option value="1994">1984</option>
                                <option value="1994">1983</option>
                                <option value="1994">1982</option>
                                <option value="1994">1981</option>
                                <option value="1994">1980</option>
                                <option value="1994">1979</option>
                                <option value="1994">1978</option>
                                <option value="1994">1977</option>
                                <option value="1994">1976</option>
                                <option value="1994">1975</option>
                                <option value="1994">1974</option>
                                <option value="1994">1973</option>
                                <option value="1994">1972</option>
                                <option value="1994">1971</option>
                                <option value="1994">1970</option>
                                <option value="1994">1969</option>
                                <option value="1994">1968</option>
                                <option value="1994">1967</option>
                                <option value="1994">1966</option>
                                <option value="1994">1965</option>
                                <option value="1994">1964</option>
                                <option value="1994">1963</option>
                                <option value="1994">1962</option>
                                <option value="1994">1961</option>
                                <option value="1994">1960</option>
                              </select>
                            </div>
                          </div>
                          <div className="fx-cl spacem regFormfloat">
                            <label className="inputCont" htmlFor="text">
                              Certificate obtained:
                            </label>
                            <div className="fx-ac space1 regInputCont">
                              <select
                                name="junior_sec_sch_cert"
                                id=""
                                value={applicantData.junior_sec_Cert}
                                onChange={(event) =>
                                  setApplicantData({
                                    junior_sec_Cert: event.target.value,
                                  })
                                }
                              >
                                <option value="" hidden>
                                  Select option
                                </option>
                                <option value="Primary school leaving certificate">
                                  Primary school leaving certificate
                                </option>
                                <option value="JSSLCE">JSSLCE</option>
                                <option value="SSCE">SSCE</option>
                                <option value="WASSCE">WASSCE</option>
                                <option value="NABTEB">NABTEB</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="eduRec space1 rwdG4">
                          <div className="fx-cl spacem regFormfloat">
                            <label className="inputCont" htmlFor="text">
                              Senior Secondary school attended:
                            </label>
                            <div className="fx-ac space1 regInputCont">
                              <input
                                type="text"
                                name="senior_sec_name"
                                value={applicantData.senior_sec_Name}
                                onChange={(event) =>
                                  setApplicantData({
                                    senior_sec_Name: event.target.value,
                                  })
                                }
                              />
                            </div>
                          </div>
                          <div className="fx-cl spacem regFormfloat">
                            <label className="inputCont" htmlFor="text">
                              From:
                            </label>
                            <div className="fx-ac space1 regInputCont">
                              <select
                                name="senior_sec_from"
                                id=""
                                value={applicantData.senior_sec_From}
                                onChange={(event) =>
                                  setApplicantData({
                                    senior_sec_From: event.target.value,
                                  })
                                }
                              >
                                <option value="" hidden>
                                  Select year started
                                </option>
                                <option value="2024">2024</option>
                                <option value="2023">2023</option>
                                <option value="2022">2022</option>
                                <option value="2021">2021</option>
                                <option value="2020">2020</option>
                                <option value="2019">2019</option>
                                <option value="2018">2018</option>
                                <option value="2017">2017</option>
                                <option value="2016">2016</option>
                                <option value="2015">2015</option>
                                <option value="2014">2014</option>
                                <option value="2013">2013</option>
                                <option value="2012">2012</option>
                                <option value="2011">2011</option>
                                <option value="2010">2010</option>
                                <option value="2009">2009</option>
                                <option value="2008">2008</option>
                                <option value="2007">2007</option>
                                <option value="2006">2006</option>
                                <option value="2005">2005</option>
                                <option value="2004">2004</option>
                                <option value="2003">2003</option>
                                <option value="2002">2002</option>
                                <option value="2001">2001</option>
                                <option value="2000">2000</option>
                                <option value="1999">1999</option>
                                <option value="1998">1998</option>
                                <option value="1997">1997</option>
                                <option value="1996">1996</option>
                                <option value="1995">1995</option>
                                <option value="1994">1994</option>
                                <option value="1994">1993</option>
                                <option value="1994">1992</option>
                                <option value="1994">1991</option>
                                <option value="1994">1990</option>
                                <option value="1994">1989</option>
                                <option value="1994">1988</option>
                                <option value="1994">1987</option>
                                <option value="1994">1986</option>
                                <option value="1994">1985</option>
                                <option value="1994">1984</option>
                                <option value="1994">1983</option>
                                <option value="1994">1982</option>
                                <option value="1994">1981</option>
                                <option value="1994">1980</option>
                                <option value="1994">1979</option>
                                <option value="1994">1978</option>
                                <option value="1994">1977</option>
                                <option value="1994">1976</option>
                                <option value="1994">1975</option>
                                <option value="1994">1974</option>
                                <option value="1994">1973</option>
                                <option value="1994">1972</option>
                                <option value="1994">1971</option>
                                <option value="1994">1970</option>
                                <option value="1994">1969</option>
                                <option value="1994">1968</option>
                                <option value="1994">1967</option>
                                <option value="1994">1966</option>
                                <option value="1994">1965</option>
                                <option value="1994">1964</option>
                                <option value="1994">1963</option>
                                <option value="1994">1962</option>
                                <option value="1994">1961</option>
                                <option value="1994">1960</option>
                              </select>
                            </div>
                          </div>
                          <div className="fx-cl spacem regFormfloat">
                            <label className="inputCont" htmlFor="text">
                              To:
                            </label>
                            <div className="fx-ac space1 regInputCont">
                              <select
                                name="senior_sec_end"
                                id=""
                                value={applicantData.senior_sec_To}
                                onChange={(event) =>
                                  setApplicantData({
                                    senior_sec_To: event.target.value,
                                  })
                                }
                              >
                                <option value="" hidden>
                                  Select year end
                                </option>

                                <option value="2026">2026</option>
                                <option value="2025">2025</option>
                                <option value="2024">2024</option>
                                <option value="2023">2023</option>
                                <option value="2022">2022</option>
                                <option value="2021">2021</option>
                                <option value="2020">2020</option>
                                <option value="2019">2019</option>
                                <option value="2018">2018</option>
                                <option value="2017">2017</option>
                                <option value="2016">2016</option>
                                <option value="2015">2015</option>
                                <option value="2014">2014</option>
                                <option value="2013">2013</option>
                                <option value="2012">2012</option>
                                <option value="2011">2011</option>
                                <option value="2010">2010</option>
                                <option value="2009">2009</option>
                                <option value="2008">2008</option>
                                <option value="2007">2007</option>
                                <option value="2006">2006</option>
                                <option value="2005">2005</option>
                                <option value="2004">2004</option>
                                <option value="2003">2003</option>
                                <option value="2002">2002</option>
                                <option value="2001">2001</option>
                                <option value="2000">2000</option>
                                <option value="1999">1999</option>
                                <option value="1998">1998</option>
                                <option value="1997">1997</option>
                                <option value="1996">1996</option>
                                <option value="1995">1995</option>
                                <option value="1994">1994</option>
                                <option value="1994">1993</option>
                                <option value="1994">1992</option>
                                <option value="1994">1991</option>
                                <option value="1994">1990</option>
                                <option value="1994">1989</option>
                                <option value="1994">1988</option>
                                <option value="1994">1987</option>
                                <option value="1994">1986</option>
                                <option value="1994">1985</option>
                                <option value="1994">1984</option>
                                <option value="1994">1983</option>
                                <option value="1994">1982</option>
                                <option value="1994">1981</option>
                                <option value="1994">1980</option>
                                <option value="1994">1979</option>
                                <option value="1994">1978</option>
                                <option value="1994">1977</option>
                                <option value="1994">1976</option>
                                <option value="1994">1975</option>
                                <option value="1994">1974</option>
                                <option value="1994">1973</option>
                                <option value="1994">1972</option>
                                <option value="1994">1971</option>
                                <option value="1994">1970</option>
                                <option value="1994">1969</option>
                                <option value="1994">1968</option>
                                <option value="1994">1967</option>
                                <option value="1994">1966</option>
                                <option value="1994">1965</option>
                                <option value="1994">1964</option>
                                <option value="1994">1963</option>
                                <option value="1994">1962</option>
                                <option value="1994">1961</option>
                                <option value="1994">1960</option>
                              </select>
                            </div>
                          </div>
                          <div className="fx-cl spacem regFormfloat">
                            <label className="inputCont" htmlFor="text">
                              Certificate obtained:
                            </label>
                            <div className="fx-ac space1 regInputCont">
                              <select
                                name="senior_sec_cert"
                                id=""
                                value={applicantData.senior_sec_Cert}
                                onChange={(event) =>
                                  setApplicantData({
                                    senior_sec_Cert: event.target.value,
                                  })
                                }
                              >
                                <option value="" hidden>
                                  Select option
                                </option>
                                <option value="Primary school leaving certificate">
                                  Primary school leaving certificate
                                </option>
                                <option value="JSSLCE">JSSLCE</option>
                                <option value="SSCE">SSCE</option>
                                <option value="WASSCE">WASSCE</option>
                                <option value="NABTEB">NABTEB</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="fileUpload space2 regformSect">
                        <div className="tag">
                          <span>Documents attached to the application:</span>
                        </div>
                        <div className="fx-cl spacem">
                          <span>
                            Please upload each document in it unique field
                            below:
                          </span>

                          <FileUploads setSignature={setSignature} />
                        </div>
                        <div className="fx-cl spacem"></div>
                      </div>
                      <div className="refsCont fx-cl space6 regformSect ">
                        <div className="tag">
                          <span>Refrees and Next of kin:</span>
                        </div>
                        <div className="refItem space2 rwdG4">
                          <div className="fx-cl spacem regFormfloat">
                            <label className="inputCont" htmlFor="text">
                              Refree name 1:
                            </label>
                            <div className="fx-ac space1 regInputCont">
                              <input
                                type="text"
                                name="ref1_name"
                                value={applicantData.firstRef_name}
                                onChange={(event) =>
                                  setApplicantData({
                                    firstRef_name: event.target.value,
                                  })
                                }
                              />
                            </div>
                          </div>
                          <div className="fx-cl spacem regFormfloat">
                            <label className="inputCont" htmlFor="text">
                              Refree address:
                            </label>
                            <div className="fx-ac space1 regInputCont">
                              <input
                                type="text"
                                name="ref1_address"
                                value={applicantData.firstRef_address}
                                onChange={(event) =>
                                  setApplicantData({
                                    firstRef_address: event.target.value,
                                  })
                                }
                              />
                            </div>
                          </div>
                          <div className="fx-cl spacem regFormfloat">
                            <label className="inputCont" htmlFor="text">
                              Refree email:
                            </label>
                            <div className="fx-ac space1 regInputCont">
                              <input
                                type="text"
                                name="ref1_email"
                                value={applicantData.firstRef_email}
                                onChange={(event) =>
                                  setApplicantData({
                                    firstRef_email: event.target.value,
                                  })
                                }
                              />
                            </div>
                          </div>
                          <div className="fx-cl spacem regFormfloat">
                            <label className="inputCont" htmlFor="text">
                              Refree phone number:
                            </label>
                            <div className="fx-ac space1 regInputCont">
                              <input
                                type="text"
                                name="ref1_phone"
                                value={applicantData.firstRef_phone}
                                onChange={(event) =>
                                  setApplicantData({
                                    firstRef_phone: event.target.value,
                                  })
                                }
                              />
                            </div>
                          </div>
                        </div>
                        <div className="refItem space2 rwdG4">
                          <div className="fx-cl spacem regFormfloat">
                            <label className="inputCont" htmlFor="text">
                              Refree 2 name:
                            </label>
                            <div className="fx-ac space1 regInputCont">
                              <input
                                type="text"
                                name="ref2_name"
                                value={applicantData.secondRef_name}
                                onChange={(event) =>
                                  setApplicantData({
                                    secondRef_name: event.target.value,
                                  })
                                }
                              />
                            </div>
                          </div>
                          <div className="fx-cl spacem regFormfloat">
                            <label className="inputCont" htmlFor="text">
                              Refree 2 address:
                            </label>
                            <div className="fx-ac space1 regInputCont">
                              <input
                                type="text"
                                name="ref2_address"
                                value={applicantData.secondRef_address}
                                onChange={(event) =>
                                  setApplicantData({
                                    secondRef_address: event.target.value,
                                  })
                                }
                              />
                            </div>
                          </div>
                          <div className="fx-cl spacem regFormfloat">
                            <label className="inputCont" htmlFor="text">
                              Refree 2 email:
                            </label>
                            <div className="fx-ac space1 regInputCont">
                              <input
                                type="text"
                                name="ref2_email"
                                value={applicantData.secondRef_email}
                                onChange={(event) =>
                                  setApplicantData({
                                    secondRef_email: event.target.value,
                                  })
                                }
                              />
                            </div>
                          </div>
                          <div className="fx-cl spacem regFormfloat">
                            <label className="inputCont" htmlFor="text">
                              Refree 2 phone number:
                            </label>
                            <div className="fx-ac space1 regInputCont">
                              <input
                                type="text"
                                name="ref2_phone"
                                value={applicantData.secondRef_phone}
                                onChange={(event) =>
                                  setApplicantData({
                                    secondRef_phone: event.target.value,
                                  })
                                }
                              />
                            </div>
                          </div>
                        </div>
                        <div className="refItem space2 rwdG4">
                          <div className="fx-cl spacem regFormfloat">
                            <label className="inputCont" htmlFor="text">
                              Next of kin name:
                            </label>
                            <div className="fx-ac space1 regInputCont">
                              <input
                                type="text"
                                name="nok_name"
                                value={applicantData.nok_name}
                                onChange={(event) =>
                                  setApplicantData({
                                    nok_name: event.target.value,
                                  })
                                }
                              />
                            </div>
                          </div>
                          <div className="fx-cl spacem regFormfloat">
                            <label className="inputCont" htmlFor="text">
                              address:
                            </label>
                            <div className="fx-ac space1 regInputCont">
                              <input
                                type="text"
                                name="nok_address"
                                value={applicantData.nok_address}
                                onChange={(event) =>
                                  setApplicantData({
                                    nok_address: event.target.value,
                                  })
                                }
                              />
                            </div>
                          </div>
                          <div className="fx-cl spacem regFormfloat">
                            <label className="inputCont" htmlFor="text">
                              NOK Relationship:
                            </label>
                            <div className="fx-ac space1 regInputCont">
                              <input
                                type="text"
                                name="nok_relation"
                                value={applicantData.nok_relationship}
                                onChange={(event) =>
                                  setApplicantData({
                                    nok_relationship: event.target.value,
                                  })
                                }
                              />
                            </div>
                          </div>
                          <div className="fx-cl spacem regFormfloat">
                            <label className="inputCont" htmlFor="text">
                              Phone number:
                            </label>
                            <div className="fx-ac space1 regInputCont">
                              <input
                                type="text"
                                name="nok_phone"
                                value={applicantData.nok_phone}
                                onChange={(event) =>
                                  setApplicantData({
                                    nok_phone: event.target.value,
                                  })
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className=" regformSect">
                        <div className="tag">
                          <span>Notes:</span>
                        </div>
                        <p className="fx-jc spacem">
                          <span style={{ padding: "0.7rem" }}>
                            <input
                              type="checkbox"
                              name="agree"
                              id=""
                              onChange={() => setAgreed(!agreed)}
                            />
                          </span>
                          <span className="aggreementForomCompletion">
                            By clicking the "Agree" button, you confirm that the
                            information provided in this application form is
                            accurate and complete to the best of your knowledge.
                            You acknowledge that providing false or misleading
                            information may result in the rejection of your
                            application or other consequences as determined by
                            the institution.
                          </span>
                        </p>
                      </div>
                      <div className="fx-jb">
                        <span>&nbsp;</span>
                        {/* <button onClick={() => setSwitchForm(2)}>
                          Continue
                        </button> */}
                        <Modal
                          isOpen={isModalOpen}
                          onClose={() => setIsModalOpen(false)}
                        >
                          {passport && signature ? (
                            <div className="regValidationCont fx-cl space1">
                              <h2
                                style={{ fontSize: "20px", fontWeight: "bold" }}
                              >
                                <WarningAmberIcon
                                  style={{
                                    fontSize: "6.4rem",
                                    color: "#dc4d37",
                                  }}
                                />
                              </h2>
                              <p
                                style={{
                                  marginTop: "10px",
                                  fontSize: "1.8rem",
                                  fontWeight: "200",
                                }}
                              >
                                Are sure you want to sumbit your application?
                              </p>
                              <p
                                style={{
                                  fontSize: "1.4rem",
                                  fontWeight: "300",
                                }}
                              >
                                Are you sure that the information provided in
                                this application form is accurate and completed?
                              </p>
                              <div className="fx-ac fx-jb space3">
                                <button
                                  style={{ backgroundColor: "#dc4d37" }}
                                  onClick={() => setIsModalOpen(false)}
                                >
                                  Cancel
                                </button>
                                <button
                                  onClick={() => postApplicatonForm()}
                                  style={{ backgroundColor: "#64f727" }}
                                >
                                  Submit
                                </button>
                              </div>
                            </div>
                          ) : (
                            <div className="regValidationCont fx-cl space1">
                              <h2
                                style={{ fontSize: "20px", fontWeight: "bold" }}
                              >
                                <WarningAmberIcon
                                  style={{
                                    fontSize: "6.4rem",
                                    color: "#dc4d37",
                                  }}
                                />
                              </h2>
                              <p
                                style={{
                                  marginTop: "10px",
                                  fontSize: "1.8rem",
                                  fontWeight: "200",
                                }}
                              >
                                Please upload passport photograph and your
                                signature to proceed
                              </p>
                              <p
                                style={{
                                  fontSize: "1.4rem",
                                  fontWeight: "300",
                                }}
                              >
                                Make sure you uploaded both your passport
                                photograph and signature to continue
                              </p>
                              <div className="fx-ac fx-jb space3">
                                <button
                                  style={{ backgroundColor: "#dc4d37" }}
                                  onClick={() => setIsModalOpen(false)}
                                >
                                  Close
                                </button>
                                <span>&nbsp;</span>
                              </div>
                            </div>
                          )}
                        </Modal>
                        {agreed ? (
                          <button onClick={() => setIsModalOpen(true)}>
                            Submit form
                          </button>
                        ) : (
                          <button
                            style={{
                              backgroundColor: "#bbbbbb",
                              cursor: "not-allowed",
                            }}
                          >
                            Submit form
                          </button>
                        )}
                      </div>
                    </div>
                  ) : (
                    formSwitching()
                  )}
                </div>
                <aside style={{ textAlign: "center" }}>
                  already have an account? &nbsp;
                  <Link>
                    <strong>Sign in</strong>
                  </Link>
                </aside>
              </div>
            </div>
          )}
        </section>
      )}
    </>
  );
}
